/**
 * HyperOTP Login System
 * This script handles OTP-based authentication, Google SSO, and Facebook SSO integration
 * for Shopify stores. It provides a modern, secure login experience with multiple
 * authentication methods.
 */

// Load Inter font from Google Fonts
(function injectInterFont() {
    if (document.getElementById('hyperotp-inter-font-link')) return;
    const link = document.createElement('link');
    link.id = 'hyperotp-inter-font-link';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;450;500;550;600;650;700&display=swap';
    document.head.appendChild(link);
  })();
  
  // Add a temporary CSS at the very top to immediately hide the default Shopify login form
  (function injectTempHideLoginCSS() {
    if (document.getElementById('hyperotp-temp-hide-login-style')) return;
    const style = document.createElement("style");
    style.id = "hyperotp-temp-hide-login-style";
    style.innerHTML = `
      /* Hide only the native login form and its built-in titles; keep wrappers visible */
      form[action*="/account/login"],
      #customer_login,
      form[action*="/account/login"] *,
      #customer_login h1,
      #customer_login h2,
      /* Common theme headings/text around login */
      .customer.login #login,
      .customer.login .login__text,
      .customer.login .section-content__text,
      .section-header__title,
      /* Hide drawer-based login forms */
      .t4s-content-login-sidebar form[action*="/account/login"],
      .login-sidebar form[action*="/account/login"],
      .drawer-login form[action*="/account/login"],
      [class*="login-sidebar"] form[action*="/account/login"],
      [class*="drawer-login"] form[action*="/account/login"],
      #login_login-sidebar form,
      #halo-auth-sidebar,
      .login-form-container form,
      [id*="login_login"] form,
      .login-title,
      .form-title,
      .customer-login-title {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        z-index: -1 !important;
      }
      
      /* Drawer-specific styling */
    .t4s-content-login-sidebar .otp-login-container,
    .login-sidebar .otp-login-container,
    .drawer-login .otp-login-container,
    [class*="login-sidebar"] .otp-login-container,
    [class*="drawer-login"] .otp-login-container {
        background: transparent !important;
        max-width: 100% !important;
        margin: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        padding: 0 !important;
      }
      
      /* Ensure drawer content is visible */
      .t4s-content-login-sidebar,
      .login-sidebar,
      .drawer-login,
      [class*="login-sidebar"],
      [class*="drawer-login"] {
        display: block !important;
        visibility: visible !important;
      }
      /* Hide promotional elements on login page only */
      body[data-template*="customers/login"] h2.section-title.title.inline-richtext,
      body[data-template*="customers/login"] .section-text.login_description,
      body[data-template*="customers/login"] .banner_buttons--multiple a[href="/account/register"],
      body[data-template*="customers/login"] .inline-block.max-w-xl,
      body[data-template*="customers/login"] .login-rowRight,
      /* Alternative selectors for different theme structures */
      h2.section-title.title.inline-richtext,
      .section-text.login_description,
      .banner_buttons--multiple a[href="/account/register"],
      .inline-block.max-w-xl,
      .login-rowRight {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        z-index: -1 !important;
      }
    `;
    document.head.appendChild(style);
  })();
  
  console.log("✅ login-override.js loaded");
  
const HYPEROTP_DRAWER_HOST_SELECTORS = [
  '.t4s-content-login-sidebar',
  '.login-sidebar',
  '.drawer-login',
  '[class*="login-sidebar"]',
  '[class*="drawer-login"]',
  '#halo-auth-sidebar',
  '.halo-auth-sidebar',
  '.halo-sidebar__wrapper',
  '.halo-sidebar__content',
  '.halo-sidebar__login'
];

const HYPEROTP_DRAWER_HOST_SELECTOR = HYPEROTP_DRAWER_HOST_SELECTORS.join(', ');
const processedDrawerForms = new WeakSet();

function getDrawerHost(element) {
  if (!element || typeof element.closest !== 'function' || !HYPEROTP_DRAWER_HOST_SELECTOR) {
    return null;
  }
  return element.closest(HYPEROTP_DRAWER_HOST_SELECTOR);
}

function isLoginTemplatePage() {
  const body = document.body;
  if (!body) return false;
  
  const pathname = window.location.pathname.toLowerCase();
  const templateAttr = body.getAttribute('data-template') || (body.dataset ? body.dataset.template : '') || '';
  const className = body.className || '';
  const pageTemplate = body.getAttribute('data-page-template') || '';
  
  // Check multiple conditions for login page detection
  const isLoginPath = pathname.includes('/account/login') || pathname.endsWith('/login');
  const isLoginTemplate = templateAttr.includes('customers/login') || templateAttr.includes('customer-login') || templateAttr === 'login';
  const hasLoginClass = className.includes('template-customers-login') || className.includes('customer-login') || className.includes('page-login');
  const isLoginPageTemplate = pageTemplate.includes('login');
  
  return isLoginPath || isLoginTemplate || hasLoginClass || isLoginPageTemplate;
}

function findInlineLoginForm() {
  const forms = Array.from(document.querySelectorAll('form[action*="/account/login"]'));
  return forms.find(form => !getDrawerHost(form));
}

function restoreHiddenDrawerForm(otpContainer) {
  if (!otpContainer || !Array.isArray(otpContainer.__hyperotpHiddenForms)) return;
  otpContainer.__hyperotpHiddenForms.forEach(hiddenForm => {
    if (!hiddenForm) return;
    hiddenForm.style.display = '';
    hiddenForm.removeAttribute('data-hyperotp-hidden');
  });
  otpContainer.__hyperotpHiddenForms = [];
}

function destroyOtpContainer(otpContainer) {
  if (!otpContainer) return;
  restoreHiddenDrawerForm(otpContainer);
  otpContainer.remove();
}

function linkHiddenFormToContainer(otpContainer, form) {
  if (!otpContainer || !form) return;
  if (!Array.isArray(otpContainer.__hyperotpHiddenForms)) {
    otpContainer.__hyperotpHiddenForms = [];
  }
  if (!otpContainer.__hyperotpHiddenForms.includes(form)) {
    otpContainer.__hyperotpHiddenForms.push(form);
  }
  form.style.display = 'none';
  form.setAttribute('data-hyperotp-hidden', 'true');
}

  /**
   * SECTION: Dynamic Button Color System
   * Handles dynamic button coloring based on settings
   */
  
  // Function to get button color from settings or default
  function getButtonColor() {
    if (window.hyperOTPSettings && window.hyperOTPSettings.buttonColor) {
      return window.hyperOTPSettings.buttonColor;
    }
    return '#ffffff'; // Default white color until settings are loaded
  }
  
  // Function to generate darker shade for hover effects
  function getDarkerButtonColor(color) {
    // Convert hex to RGB, darken it, then convert back
    let r = parseInt(color.slice(1, 3), 16);
    let g = parseInt(color.slice(3, 5), 16);
    let b = parseInt(color.slice(5, 7), 16);
  
    // Darken by 20%
    r = Math.floor(r * 0.8);
    g = Math.floor(g * 0.8);
    b = Math.floor(b * 0.8);
  
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
  }
  
  // Function to get contrasting text color (white or black)
  function getTextColorForButton(backgroundColor) {
    if (window.hyperOTPSettings && window.hyperOTPSettings.textColor) {
      return window.hyperOTPSettings.textColor;
    }
  
    // If no text color setting, auto-determine based on background
    const r = parseInt(backgroundColor.slice(1, 3), 16);
    const g = parseInt(backgroundColor.slice(3, 5), 16);
    const b = parseInt(backgroundColor.slice(5, 7), 16);
  
    // Calculate luminance
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
    return luminance > 0.5 ? '#000000' : '#ffffff';
  }
  
  // Function to get login header text from settings
  function getLoginHeaderText() {
    if (window.hyperOTPSettings && window.hyperOTPSettings.loginHeader) {
      return window.hyperOTPSettings.loginHeader;
    }
    return 'Login/Signup'; // Default text until settings are loaded
  }
  
  // Function to get login header color from settings
  function getLoginHeaderColor() {
    if (window.hyperOTPSettings && window.hyperOTPSettings.loginHeaderColor) {
      return window.hyperOTPSettings.loginHeaderColor;
    }
    return '#ffffff'; // Default white color until settings are loaded
  }
  
  // Function to generate dynamic button CSS
  function generateDynamicButtonCSS() {
    const buttonColor = getButtonColor();
    const hoverColor = getDarkerButtonColor(buttonColor);
    const textColor = getTextColorForButton(buttonColor);
  
    return `
      .otp-btn {
        background: ${buttonColor} !important;
        color: ${textColor} !important;
        border: none !important;
      }
      .otp-btn:hover {
        background: ${hoverColor} !important;
      }
      .otp-verify-btn {
        background: ${buttonColor} !important;
        color: ${textColor} !important;
        border: none !important;
      }
      .otp-verify-btn:hover {
        background: ${hoverColor} !important;
      }
      .signup-btn {
        background: ${buttonColor} !important;
        color: ${textColor} !important;
        border: none !important;
      }
      .signup-btn:hover {
        background: ${hoverColor} !important;
      }
    `;
  }
  
  // Function to generate dynamic header CSS
  function generateDynamicHeaderCSS() {
    const headerColor = getLoginHeaderColor();
  
    return `
      .otp-login-container h2,
      .otp-title,
      .otp-verify-title {
        color: ${headerColor} !important;
      }
    `;
  }
  
  // Function to inject or update dynamic styles (buttons and headers)
  function updateButtonColors() {
    let styleElement = document.getElementById('hyperotp-dynamic-button-styles');
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.id = 'hyperotp-dynamic-button-styles';
      document.head.appendChild(styleElement);
    }
    styleElement.innerHTML = generateDynamicButtonCSS() + generateDynamicHeaderCSS();
  }
  
  // Function to update header text content
  function updateHeaderText() {
    const headerText = getLoginHeaderText();
  
    // Update all header elements with the dynamic text
    const headers = document.querySelectorAll('.otp-login-container h2, .otp-title');
    headers.forEach(header => {
      if (header.textContent === 'Login/Signup' || header.textContent.includes('Login')) {
        header.textContent = headerText;
      }
    });
  }
  
  // Initialize with default colors and header text immediately
  updateButtonColors();
  updateHeaderText();
  
  // Listen for settings updates and refresh button colors
  if (window.addEventListener) {
    window.addEventListener('hyperotp-settings-loaded', function () {
      updateButtonColors();
      updateHeaderText();
    });
  }
  
  /**
   * SECTION: Initial Setup
   * Injects required scripts and sets up the base configuration
   */
  
  // Function to check which social logins are enabled
  function getEnabledSocialLogins() {
    if (!window.hyperOTPSettings || !window.hyperOTPSettings.socialLogins) {
      return { google: false, facebook: false };
    }
    const socialLogins = window.hyperOTPSettings.socialLogins.toLowerCase().split(',');
    return {
      google: socialLogins.includes('google'),
      facebook: socialLogins.includes('facebook')
    };
  }
  
  // Function to check if OTP form should be shown
  function shouldShowOTPForm() {
    if (!window.hyperOTPSettings) return true;
    const method = window.hyperOTPSettings.loginMethod;
    return method === "ONLY_PHONE" || method === "EMAIL_AND_PHONE";
  }
  
  // Function to check if email password login should be shown
  function shouldShowEmailPasswordLogin() {
    if (!window.hyperOTPSettings) return true;
    const method = window.hyperOTPSettings.loginMethod;
    return method === "ONLY_EMAIL_PASSWORD" || method === "EMAIL_AND_PHONE";
  }
  
  // Function to generate social login buttons HTML based on settings
  function generateSocialButtonsHTML() {
    const { google, facebook } = getEnabledSocialLogins();
    if (!google && !facebook) return '';
  
    let html = '<div class="otp-social-row">';
  
    if (google) {
      html += `
        <!-- Server-side Google SSO Button -->
        <button type="button" class="otp-social-btn google-sso-btn" onclick="event.preventDefault(); var shop = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'yourshop.myshopify.com'; window.open('https://hyperotp.onrender.com/app/authgoogle?shop=' + encodeURIComponent(shop), 'googleSSO', 'width=500,height=600'); return false;">
          <img src='https://img.icons8.com/color/48/google-logo.png' alt='Google' />
        </button>
      `;
    }
  
    if (facebook) {
      html += `
        <!-- Server-side Facebook SSO Button -->
        <button type="button" class="otp-social-btn social-btn facebook-sso-btn">
          <img src='https://img.icons8.com/fluency/48/facebook-new.png' alt='Facebook' />
          <span style="font-size:0;">Facebook</span>
        </button>
      `;
    }
  
    html += '</div>';
    return html;
  }
  
  // Function to fetch settings from app proxy
  async function fetchHyperOTPSettings() {
    try {
      // Check if settings are available from window object (from login-embed.liquid)
      // Only use metafield settings if they exist and are not empty
      if (window.hyperOTPUserData &&
        window.hyperOTPUserData.settings &&
        typeof window.hyperOTPUserData.settings === 'object' &&
        window.hyperOTPUserData.settings !== null &&
        Object.keys(window.hyperOTPUserData.settings).length > 0) {
        window.hyperOTPSettings = window.hyperOTPUserData.settings;
        console.log("✅ HyperOTP Settings loaded from metafield:", window.hyperOTPUserData.settings);
        return window.hyperOTPUserData.settings;
      }
  
      // Fallback to API call if window object is not available
      console.log("⚠️ Settings not found in window object, falling back to API call");
      const res = await fetch("/apps/hyperotp", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ step: "settings" })
      });
      const result = await res.json();
      if (result.success) {
        window.hyperOTPSettings = result.settings;
        console.log("✅ HyperOTP Settings loaded:", result.settings);
        return result.settings;
      } else {
        console.error("❌ Failed to load settings:", result.error);
        return null;
      }
    } catch (error) {
      console.error("❌ Failed to load settings:", error);
      return null;
    }
  }
  
  // Inject Google SSO script
  (function injectGoogleSSOScript() {
    if (!document.querySelector('script[src*="accounts.google.com/gsi/client"]')) {
      const script = document.createElement('script');
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  })();
  
  /**
   * SECTION: Main Login UI Setup
   * Sets up the login interface and handles form visibility
   */
  // Start fetching settings as soon as script loads
  let hyperOTPSettingsPromise = fetchHyperOTPSettings();
  
  // Function to detect Shopify login errors
  function isShopifyLoginErrorPresent() {
    // Check for common Shopify error selectors
    const errorSelectors = [
      '.form-message', // Shopify Dawn theme
      '.errors',       // Older themes
      '.form__message', // Some other themes
    ];
    return errorSelectors.some(sel => {
      const el = document.querySelector(sel);
      if (el && el.textContent && el.textContent.trim().length > 0) {
        // Check if it's actually an error message (contains error keywords)
        const text = el.textContent.toLowerCase();
        const errorKeywords = ['error', 'invalid', 'incorrect', 'failed', 'wrong', 'not found'];
        return errorKeywords.some(keyword => text.includes(keyword));
      }
      return false;
    });
  }
  
  document.addEventListener("DOMContentLoaded", () => {
  
    // Check for SSO auto-login parameters first
    const urlParams = new URLSearchParams(window.location.search);
    const ssoEmail = urlParams.get('sso_email');
    const ssoPassword = urlParams.get('sso_password');
  
    if (ssoEmail && ssoPassword) {
      // Don't render OTP form if SSO auto-login is happening
      return;
    }
  
    // If Shopify login error is present, do not inject OTP UI
    if (isShopifyLoginErrorPresent()) {
      // Optionally, remove any temp CSS you injected
      const tempStyle = document.getElementById('hyperotp-temp-hide-login-style');
      if (tempStyle) tempStyle.remove();
      return;
    }
    const inlineLoginForm = findInlineLoginForm();
    const isLoginPage = isLoginTemplatePage();
    const shouldRenderPrimaryOTP = isLoginPage || !!inlineLoginForm;
    
    // 1. Render the OTP form immediately with loading state
    if (!document.getElementById('otp-login-container') && shouldRenderPrimaryOTP) {
      const otpContainer = document.createElement("div");
      otpContainer.id = "otp-login-container";
      otpContainer.className = "otp-login-container otp-fade-in";
      otpContainer.dataset.hyperotpContext = 'primary';
      otpContainer.style.cssText = `
        background: #fff;
        max-width: 470px;
        margin: 40px auto;
        border-radius: 16px;
        box-shadow: 0 2px 12px rgba(0,0,0,0.07);
        padding: 12px 24px 24px 24px;
        font-family: 'Inter', sans-serif;
        opacity: 0;
        transition: opacity 0.33s cubic-bezier(.4,0,.2,1);
        width: 100%;
        box-sizing: border-box;
      `;
      renderInitialForm(otpContainer, { loadingSocial: true });
      
      // IMPORTANT: On the dedicated /account/login page, skip drawer detection
      // Drawer logic should only apply to header/sidebar drawers, not the main login page
      let useDrawerMode = false;
      let drawerLoginContainer = null;
      
      if (!isLoginPage) {
        // Only check for drawer containers when NOT on the dedicated login page
        drawerLoginContainer = document.querySelector('.t4s-content-login-sidebar, .login-sidebar, .drawer-login, [class*="login-sidebar"], [class*="drawer-login"]');
        useDrawerMode = !!drawerLoginContainer;
      }
      
      try {
      if (useDrawerMode && drawerLoginContainer) {
        // For drawer systems, replace the content inside the drawer
        const activeLoginDiv = drawerLoginContainer.querySelector('#login_login-sidebar, .login-form-container, [id*="login_login"]');
        if (activeLoginDiv) {
          // Replace the active login div content with our OTP form
          activeLoginDiv.innerHTML = '';
          activeLoginDiv.appendChild(otpContainer);
          // Update drawer styling to accommodate OTP form
          otpContainer.style.cssText = `
            background: transparent;
            max-width: 100%;
            margin: 0;
            border-radius: 0;
            box-shadow: none;
            padding: 0;
            font-family: 'Inter', sans-serif;
            opacity: 0;
            transition: opacity 0.33s cubic-bezier(.4,0,.2,1);
            width: 100%;
            box-sizing: border-box;
          `;
        } else {
          // Fallback: append to drawer container
          drawerLoginContainer.appendChild(otpContainer);
        }
      } else {
          // Special case for stores with .customer.login.section.section--padding structure
          const customerLoginSection = document.querySelector('.customer.login.section.section--padding');
          
          if (customerLoginSection) {
            // Store reference to original customer login section for restoration
            originalCustomerLoginSection = customerLoginSection;
            // Instead of replacing, hide the original section and insert our OTP form before it
            customerLoginSection.style.display = 'none';
            customerLoginSection.parentElement.insertBefore(otpContainer, customerLoginSection);
            setTimeout(() => { otpContainer.style.opacity = '1'; }, 10);
          
            // Wait for settings to load and update the UI
            hyperOTPSettingsPromise.then(settings => {
              window.hyperOTPSettings = settings;
              
              // Update button colors and header text with loaded settings
              updateButtonColors();
              updateHeaderText();
              
              if (!settings || settings.appEnabled === false) {
                // Show the original login form and remove our OTP form
                customerLoginSection.style.display = '';
                if (otpContainer) otpContainer.remove();
                return;
              }
              
              if (settings.loginMethod === 'ONLY_EMAIL_PASSWORD') {
                // Show the original login form and remove our OTP form
                customerLoginSection.style.display = '';
                if (otpContainer) otpContainer.remove();
                return;
              }
              
              // Update the OTP UI with real settings
              hydrateOtpContainer(otpContainer);
            });
          
            return; // Exit early for this specific case
          }
        
          // Try to find the best insertion point using multiple strategies
          let insertionSuccessful = false;
          
          // Strategy 1: Hide the section-content div and insert OTP container (Tailwind themes)
          const sectionContent = document.querySelector('.section-content.lg\\:p-0.mr-auto.ml-auto.xs\\:w-full');
          
          if (sectionContent && sectionContent.parentElement) {
            // Store reference to original section content for restoration
            originalSectionContent = sectionContent;
            // Hide the original section content
            sectionContent.style.display = 'none';
            // Insert OTP container before the hidden section
            sectionContent.parentElement.insertBefore(otpContainer, sectionContent);
            insertionSuccessful = true;
          }
          
          // Strategy 2: Find native login form and insert appropriately
          if (!insertionSuccessful) {
            const nativeLoginForm = document.querySelector('form[action*="/account/login"]');
            
            if (nativeLoginForm) {
              // Check if form is inside a sidebar/drawer container (should skip for main page insertion)
              const sidebarPatterns = ['sidebar', 'drawer', 'halo-sidebar', 'offcanvas', 'slide-out', 'popup', 'modal'];
              const formParentClasses = (nativeLoginForm.parentElement?.className || '').toLowerCase();
              const isInsideSidebar = sidebarPatterns.some(pattern => formParentClasses.includes(pattern));
              
              // If form is inside a sidebar on the login page, skip to Strategy 3 (main content)
              if (isInsideSidebar && isLoginPage) {
                // Don't set insertionSuccessful, let it fall through to Strategy 3
              } else {
                // Try to find a suitable wrapper (common Shopify theme patterns)
                const wrapper = nativeLoginForm.closest('.customer.login, #login, .customer-login, .customer__login, [data-login-form], .login-form, .account-login, .shopify-section');
                
                if (wrapper && wrapper.parentElement && wrapper !== document.body) {
                  // Store reference to wrapper for restoration
                  originalSectionContent = wrapper;
                  wrapper.parentElement.insertBefore(otpContainer, wrapper);
                  // Hide the original wrapper (not our container since it's a sibling)
                  wrapper.style.display = 'none';
                  insertionSuccessful = true;
                } else if (nativeLoginForm.parentElement && nativeLoginForm.parentElement !== document.body) {
                  // Store reference to form for restoration (not the parent)
                  originalSectionContent = nativeLoginForm;
                  // Insert OTP container BEFORE the form (as sibling)
                  nativeLoginForm.parentElement.insertBefore(otpContainer, nativeLoginForm);
                  // Hide only the native form, NOT the parent
                  nativeLoginForm.style.display = 'none';
                  insertionSuccessful = true;
                }
              }
            }
          }
          
          // Strategy 3: Generic fallback - find main content area
          if (!insertionSuccessful) {
            // Try multiple selectors to find the main content area
            const mainSelectors = [
              "main",
              "#MainContent", 
              "#main",
              "#main-content",
              ".main-content",
              "[role='main']",
              ".page-content",
              ".content-wrapper",
              "#content",
              ".site-main",
              "#shopify-section-template--main",
              "[class*='template--']",
              ".template-customers-login",
              "#shopify-section-main"
            ];
            
            let main = null;
            for (const selector of mainSelectors) {
              main = document.querySelector(selector);
              if (main && main !== document.body) {
                break;
              }
            }
            
            if (main && main !== document.body) {
              // Create a centered wrapper for the OTP container
              const wrapper = document.createElement('div');
              wrapper.style.cssText = 'display: flex; justify-content: center; align-items: center; min-height: 50vh; padding: 20px;';
              wrapper.appendChild(otpContainer);
              
              // Try to insert at the beginning of main content
              if (main.firstChild) {
                main.insertBefore(wrapper, main.firstChild);
              } else {
                main.appendChild(wrapper);
              }
              insertionSuccessful = true;
            } else {
              // Last resort: create a visible container and append to body
              const wrapper = document.createElement('div');
              wrapper.style.cssText = 'display: flex; justify-content: center; align-items: center; min-height: 50vh; padding: 20px; position: relative; z-index: 100;';
              wrapper.appendChild(otpContainer);
              
              // Insert at the beginning of body, after any skip links
              const firstContent = document.body.querySelector('header, nav, .header, #header') || document.body.firstChild;
              if (firstContent) {
                firstContent.parentElement.insertBefore(wrapper, firstContent.nextSibling);
              } else {
                document.body.appendChild(wrapper);
              }
              insertionSuccessful = true;
            }
          }
      }
      setTimeout(() => { otpContainer.style.opacity = '1'; }, 10);
      } catch (insertionError) {
        console.error("[HyperOTP] Insertion error:", insertionError);
        // Fallback: try to append to body directly
        try {
          document.body.appendChild(otpContainer);
          setTimeout(() => { otpContainer.style.opacity = '1'; }, 10);
        } catch (fallbackError) {
          console.error("[HyperOTP] Fallback failed:", fallbackError);
        }
      }
    }
  
    // Remove loader if present
    const loader = document.getElementById('otp-loader');
    if (loader) loader.remove();
  
    // When settings are ready, update the UI
    hyperOTPSettingsPromise.then(settings => {
      window.hyperOTPSettings = settings;
  
      // Update button colors and header text with loaded settings
      updateButtonColors();
      updateHeaderText();
    const tempStyle = document.getElementById('hyperotp-temp-hide-login-style');
      const otpContainers = document.querySelectorAll('.otp-login-container');
      if (!settings || settings.appEnabled === false) {
        // Remove the temp CSS so default login shows
        if (tempStyle) tempStyle.remove();
        otpContainers.forEach(container => destroyOtpContainer(container));
        return;
      }
      if (settings.loginMethod === 'ONLY_EMAIL_PASSWORD') {
        if (tempStyle) tempStyle.remove();
        showShopifyDefaultLoginForm();
        return;
      }
      // Now update the OTP UI with real settings
      if (otpContainers.length) {
        otpContainers.forEach(container => hydrateOtpContainer(container));
      }
      injectHideLoginCSS();
      if (tempStyle) tempStyle.remove();
    });

    initializeDrawerLoginWatcher();
    
    // Fallback: Watch for dynamically loaded login forms on the login page
    if (isLoginPage && !document.getElementById('otp-login-container')) {
      const loginFormObserver = new MutationObserver((mutations, obs) => {
        // Check if we already have an OTP container
        if (document.getElementById('otp-login-container') || document.querySelector('.otp-login-container[data-hyperotp-context="primary"]')) {
          obs.disconnect();
          return;
        }
        
        // Look for a newly added login form
        const newLoginForm = document.querySelector('form[action*="/account/login"]');
        if (newLoginForm && !getDrawerHost(newLoginForm)) {
          obs.disconnect();
          
          // Create and insert OTP container
          const otpContainer = document.createElement("div");
          otpContainer.id = "otp-login-container";
          otpContainer.className = "otp-login-container otp-fade-in";
          otpContainer.dataset.hyperotpContext = 'primary';
          otpContainer.style.cssText = `
            background: #fff;
            max-width: 470px;
            margin: 40px auto;
            border-radius: 16px;
            box-shadow: 0 2px 12px rgba(0,0,0,0.07);
            padding: 12px 24px 24px 24px;
            font-family: 'Inter', sans-serif;
            opacity: 0;
            transition: opacity 0.33s cubic-bezier(.4,0,.2,1);
            width: 100%;
            box-sizing: border-box;
          `;
          renderInitialForm(otpContainer, { loadingSocial: true });
          
          // Insert before the form
          if (newLoginForm.parentElement) {
            newLoginForm.parentElement.insertBefore(otpContainer, newLoginForm);
            newLoginForm.style.display = 'none';
            originalSectionContent = newLoginForm;
          } else {
            const main = document.querySelector("main") || document.querySelector("#MainContent") || document.body;
            main.appendChild(otpContainer);
          }
          
          setTimeout(() => { otpContainer.style.opacity = '1'; }, 10);
          
          // Hydrate with settings if available
          if (window.hyperOTPSettings) {
            hydrateOtpContainer(otpContainer);
          } else {
            hyperOTPSettingsPromise.then(settings => {
              if (settings && settings.appEnabled !== false && settings.loginMethod !== 'ONLY_EMAIL_PASSWORD') {
                hydrateOtpContainer(otpContainer);
              }
            });
          }
        }
      });
      
      loginFormObserver.observe(document.body, { childList: true, subtree: true });
      
      // Auto-disconnect after 10 seconds to prevent memory leaks
      setTimeout(() => {
        loginFormObserver.disconnect();
      }, 10000);
    }
  });
  
  /**
   * SECTION: Phone Number Validation System
   * Comprehensive phone validation for multiple countries
   * This system is designed to be reusable, readable, and beginner-friendly
   */
  
  /**
   * Phone validation rules for different countries
   * Each country has specific validation patterns
   */
  const PHONE_VALIDATION_RULES = {
    // India: +91 followed by 10 digits
    '+91': {
      pattern: /^\+91\d{10}$/,
      minLength: 13, // +91 + 10 digits
      maxLength: 13,
      description: 'Indian mobile number (10 digits after +91)',
      example: '+91XXXXXXXXXX'
    },
    // Turkey: +90 followed by 10 digits
    '+90': {
      pattern: /^\+90\d{10}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Turkish mobile number (10 digits after +90)',
      example: '+90XXXXXXXXXX'
    },
    // USA/Canada: +1 followed by 10 digits
    '+1': {
      pattern: /^\+1\d{10}$/,
      minLength: 12,
      maxLength: 12,
      description: 'US/Canadian mobile number (10 digits after +1)',
      example: '+1XXXXXXXXXX'
    },
    // UK: +44 followed by 10-11 digits
    '+44': {
      pattern: /^\+44\d{10,11}$/,
      minLength: 13,
      maxLength: 14,
      description: 'UK mobile number (10-11 digits after +44)',
      example: '+44XXXXXXXXXX'
    },
    // Australia: +61 followed by 9 digits
    '+61': {
      pattern: /^\+61\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Australian mobile number (9 digits after +61)',
      example: '+61XXXXXXXXX'
    },
    // Mozambique: +258 followed by 9 digits
    '+258': {
      pattern: /^\+258\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Mozambican mobile number (9 digits after +258)',
      example: '+258XXXXXXXXX'
    },
    // Mexico: +52 followed by 10 digits
    '+52': {
      pattern: /^\+52\d{10}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Mexican mobile number (10 digits after +52)',
      example: '+52XXXXXXXXXX'
    },
    // China: +86 followed by 11 digits
    '+86': {
      pattern: /^\+86\d{11}$/,
      minLength: 14,
      maxLength: 14,
      description: 'Chinese mobile number (11 digits after +86)',
      example: '+86XXXXXXXXXXX'
    },
    // Thailand: +66 followed by 9 digits
    '+66': {
      pattern: /^\+66\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Thai mobile number (9 digits after +66)',
      example: '+66XXXXXXXXX'
    },
    // South Korea: +82 followed by 10-11 digits
    '+82': {
      pattern: /^\+82\d{10,11}$/,
      minLength: 13,
      maxLength: 14,
      description: 'South Korean mobile number (10-11 digits after +82)',
      example: '+82XXXXXXXXXX'
    },
    // Lithuania: +370 followed by 8 digits
    '+370': {
      pattern: /^\+370\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Lithuanian mobile number (8 digits after +370)',
      example: '+370XXXXXXXX'
    },
    // Bahrain: +973 followed by 8 digits
    '+973': {
      pattern: /^\+973\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Bahraini mobile number (8 digits after +973)',
      example: '+973XXXXXXXX'
    },
    // Poland: +48 followed by 9 digits
    '+48': {
      pattern: /^\+48\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Polish mobile number (9 digits after +48)',
      example: '+48XXXXXXXXX'
    },
    // Slovenia: +386 followed by 8 digits
    '+386': {
      pattern: /^\+386\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Slovenian mobile number (8 digits after +386)',
      example: '+386XXXXXXXX'
    },
    // Malaysia: +60 followed by 9-10 digits
    '+60': {
      pattern: /^\+60\d{9,10}$/,
      minLength: 12,
      maxLength: 13,
      description: 'Malaysian mobile number (9-10 digits after +60)',
      example: '+60XXXXXXXXX'
    },
    // UAE: +971 followed by 9 digits
    '+971': {
      pattern: /^\+971\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'UAE mobile number (9 digits after +971)',
      example: '+971XXXXXXXXX'
    },
    // Saudi Arabia: +966 followed by 9 digits
    '+966': {
      pattern: /^\+966\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Saudi mobile number (9 digits after +966)',
      example: '+966XXXXXXXXX'
    },
    // Oman: +968 followed by 8 digits
    '+968': {
      pattern: /^\+968\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Omani mobile number (8 digits after +968)',
      example: '+968XXXXXXXX'
    },
    // Japan: +81 followed by 10-11 digits
    '+81': {
      pattern: /^\+81\d{10,11}$/,
      minLength: 13,
      maxLength: 14,
      description: 'Japanese mobile number (10-11 digits after +81)',
      example: '+81XXXXXXXXXX'
    },
    // Singapore: +65 followed by 8 digits
    '+65': {
      pattern: /^\+65\d{8}$/,
      minLength: 11,
      maxLength: 11,
      description: 'Singaporean mobile number (8 digits after +65)',
      example: '+65XXXXXXXX'
    },
    // Taiwan: +886 followed by 9 digits
    '+886': {
      pattern: /^\+886\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Taiwanese mobile number (9 digits after +886)',
      example: '+886XXXXXXXXX'
    },
    // Netherlands: +31 followed by 9 digits
    '+31': {
      pattern: /^\+31\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Dutch mobile number (9 digits after +31)',
      example: '+31XXXXXXXXX'
    },
    // Vietnam: +84 followed by 9-10 digits
    '+84': {
      pattern: /^\+84\d{9,10}$/,
      minLength: 12,
      maxLength: 13,
      description: 'Vietnamese mobile number (9-10 digits after +84)',
      example: '+84XXXXXXXXX'
    },
    // Hong Kong: +852 followed by 8 digits
    '+852': {
      pattern: /^\+852\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Hong Kong mobile number (8 digits after +852)',
      example: '+852XXXXXXXX'
    },
    // New Zealand: +64 followed by 9 digits
    '+64': {
      pattern: /^\+64\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'New Zealand mobile number (9 digits after +64)',
      example: '+64XXXXXXXXX'
    },
    // Myanmar: +95 followed by 9-10 digits
    '+95': {
      pattern: /^\+95\d{9,10}$/,
      minLength: 12,
      maxLength: 13,
      description: 'Myanmar mobile number (9-10 digits after +95)',
      example: '+95XXXXXXXXX'
    },
    // Ecuador: +593 followed by 9 digits
    '+593': {
      pattern: /^\+593\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Ecuadorian mobile number (9 digits after +593)',
      example: '+593XXXXXXXXX'
    },
    // Germany: +49 followed by 10-12 digits
    '+49': {
      pattern: /^\+49\d{10,12}$/,
      minLength: 13,
      maxLength: 15,
      description: 'German mobile number (10-12 digits after +49)',
      example: '+49XXXXXXXXXX'
    },
    // Romania: +40 followed by 9 digits
    '+40': {
      pattern: /^\+40\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Romanian mobile number (9 digits after +40)',
      example: '+40XXXXXXXXX'
    },
    // Nigeria: +234 followed by 10 digits
    '+234': {
      pattern: /^\+234\d{10}$/,
      minLength: 14,
      maxLength: 14,
      description: 'Nigerian mobile number (10 digits after +234)',
      example: '+234XXXXXXXXXX'
    },
    // Italy: +39 followed by 10 digits
    '+39': {
      pattern: /^\+39\d{10}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Italian mobile number (10 digits after +39)',
      example: '+39XXXXXXXXXX'
    },
    // Spain: +34 followed by 9 digits
    '+34': {
      pattern: /^\+34\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Spanish mobile number (9 digits after +34)',
      example: '+34XXXXXXXXX'
    },
    // France: +33 followed by 9 digits
    '+33': {
      pattern: /^\+33\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'French mobile number (9 digits after +33)',
      example: '+33XXXXXXXXX'
    },
    // Norway: +47 followed by 8 digits
    '+47': {
      pattern: /^\+47\d{8}$/,
      minLength: 11,
      maxLength: 11,
      description: 'Norwegian mobile number (8 digits after +47)',
      example: '+47XXXXXXXX'
    },
    // Switzerland: +41 followed by 9 digits
    '+41': {
      pattern: /^\+41\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Swiss mobile number (9 digits after +41)',
      example: '+41XXXXXXXXX'
    },
    // Sweden: +46 followed by 9 digits
    '+46': {
      pattern: /^\+46\d{9}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Swedish mobile number (9 digits after +46)',
      example: '+46XXXXXXXXX'
    },
    // Philippines: +63 followed by 10 digits
    '+63': {
      pattern: /^\+63\d{10}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Filipino mobile number (10 digits after +63)',
      example: '+63XXXXXXXXXX'
    },
    // Azerbaijan: +994 followed by 9 digits
    '+994': {
      pattern: /^\+994\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Azerbaijani mobile number (9 digits after +994)',
      example: '+994XXXXXXXXX'
    },
    // Bangladesh: +880 followed by 10-11 digits
    '+880': {
      pattern: /^\+880\d{10,11}$/,
      minLength: 14,
      maxLength: 15,
      description: 'Bangladeshi mobile number (10-11 digits after +880)',
      example: '+880XXXXXXXXXX'
    },
    // Niger: +227 followed by 8 digits
    '+227': {
      pattern: /^\+227\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Niger mobile number (8 digits after +227)',
      example: '+227XXXXXXXX'
    },
    // Algeria: +213 followed by 9 digits
    '+213': {
      pattern: /^\+213\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Algerian mobile number (9 digits after +213)',
      example: '+213XXXXXXXXX'
    },
    // Jordan: +962 followed by 9 digits
    '+962': {
      pattern: /^\+962\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Jordanian mobile number (9 digits after +962)',
      example: '+962XXXXXXXXX'
    },
    // Cambodia: +855 followed by 8-9 digits
    '+855': {
      pattern: /^\+855\d{8,9}$/,
      minLength: 12,
      maxLength: 13,
      description: 'Cambodian mobile number (8-9 digits after +855)',
      example: '+855XXXXXXXX'
    },
    // Israel: +972 followed by 9 digits
    '+972': {
      pattern: /^\+972\d{9}$/,
      minLength: 13,
      maxLength: 13,
      description: 'Israeli mobile number (9 digits after +972)',
      example: '+972XXXXXXXXX'
    },
    // Qatar: +974 followed by 8 digits
    '+974': {
      pattern: /^\+974\d{8}$/,
      minLength: 12,
      maxLength: 12,
      description: 'Qatari mobile number (8 digits after +974)',
      example: '+974XXXXXXXX'
    },
    // Serbia: +381 followed by 8-9 digits
    '+381': {
      pattern: /^\+381\d{8,9}$/,
      minLength: 12,
      maxLength: 13,
      description: 'Serbian mobile number (8-9 digits after +381)',
      example: '+381XXXXXXXX'
    }
  };
  
  /**
   * Extracts country code from phone number
   * @param {string} phoneNumber - The complete phone number with country code
   * @returns {string|null} - Country code or null if not found
   */
  function extractCountryCodeFromPhone(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
      return null;
    }
  
    // Remove any spaces and special characters
    const cleanedPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
    // Check if phone starts with +
    if (!cleanedPhone.startsWith('+')) {
      return null;
    }
  
    // Try to match country codes (longest first to avoid partial matches)
    const countryCodes = Object.keys(PHONE_VALIDATION_RULES).sort((a, b) => b.length - a.length);
  
    for (const countryCode of countryCodes) {
      if (cleanedPhone.startsWith(countryCode)) {
        return countryCode;
      }
    }
  
    return null;
  }
  
  /**
   * Country code to country name mapping
   */
  const COUNTRY_CODE_TO_NAME = {
    '+91': 'India',
    '+90': 'Turkey',
    '+1': 'USA/Canada',
    '+44': 'UK',
    '+61': 'Australia',
    '+258': 'Mozambique',
    '+52': 'Mexico',
    '+86': 'China',
    '+66': 'Thailand',
    '+82': 'South Korea',
    '+370': 'Lithuania',
    '+973': 'Bahrain',
    '+48': 'Poland',
    '+386': 'Slovenia',
    '+60': 'Malaysia',
    '+971': 'UAE',
    '+966': 'Saudi Arabia',
    '+968': 'Oman',
    '+81': 'Japan',
    '+65': 'Singapore',
    '+886': 'Taiwan',
    '+31': 'Netherlands',
    '+84': 'Vietnam',
    '+852': 'Hong Kong',
    '+64': 'New Zealand',
    '+95': 'Myanmar',
    '+593': 'Ecuador',
    '+49': 'Germany',
    '+40': 'Romania',
    '+234': 'Nigeria',
    '+39': 'Italy',
    '+34': 'Spain',
    '+33': 'France',
    '+47': 'Norway',
    '+41': 'Switzerland',
    '+46': 'Sweden',
    '+63': 'Philippines',
    '+994': 'Azerbaijan',
    '+880': 'Bangladesh',
    '+227': 'Niger',
    '+213': 'Algeria',
    '+962': 'Jordan',
    '+855': 'Cambodia',
    '+972': 'Israel',
    '+974': 'Qatar',
    '+381': 'Serbia'
  };
  
  /**
   * Gets country name from phone number
   * @param {string} phoneNumber - The complete phone number with country code
   * @returns {string} - Country name or 'Unknown' if not found
   */
  function getCountryNameFromPhone(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') {
      return 'Unknown';
    }
  
    // Remove any spaces and special characters
    const cleanedPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
    // Check if phone starts with +
    if (!cleanedPhone.startsWith('+')) {
      return 'Unknown';
    }
  
    // Try to match country codes (longest first to avoid partial matches)
    const countryCodes = Object.keys(COUNTRY_CODE_TO_NAME).sort((a, b) => b.length - a.length);
  
    for (const countryCode of countryCodes) {
      if (cleanedPhone.startsWith(countryCode)) {
        return COUNTRY_CODE_TO_NAME[countryCode] || 'Unknown';
      }
    }
  
    return 'Unknown';
  }
  
  /**
   * Validates a phone number based on the country code
   * @param {string} phoneNumber - The complete phone number with country code
   * @param {string} countryCode - The country code (e.g., '+91', '+1')
   * @returns {Object} Validation result with success, message, and details
   */
  function validatePhoneNumber(phoneNumber, countryCode) {
    // Input validation
    if (!phoneNumber || typeof phoneNumber !== 'string') {
      return {
        isValid: false,
        message: 'Phone number is required and must be a string',
        errorType: 'INVALID_INPUT'
      };
    }
  
    if (!countryCode || typeof countryCode !== 'string') {
      return {
        isValid: false,
        message: 'Country code is required and must be a string',
        errorType: 'INVALID_COUNTRY_CODE'
      };
    }
  
    // Check if country code is supported
    if (!PHONE_VALIDATION_RULES[countryCode]) {
      return {
        isValid: false,
        message: `Country code ${countryCode} is not supported`,
        errorType: 'UNSUPPORTED_COUNTRY'
      };
    }
  
    const rule = PHONE_VALIDATION_RULES[countryCode];
  
    // Remove all spaces and special characters except digits and +
    const cleanedPhone = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
    // Check if phone number starts with the country code
    if (!cleanedPhone.startsWith(countryCode)) {
      return {
        isValid: false,
        message: `Phone number must start with ${countryCode}`,
        errorType: 'WRONG_COUNTRY_CODE',
        suggestion: `Add ${countryCode} prefix to your number`
      };
    }
  
    // Check length
    if (cleanedPhone.length < rule.minLength) {
      return {
        isValid: false,
        message: `Phone number is too short. Expected ${rule.minLength} characters, got ${cleanedPhone.length}`,
        errorType: 'TOO_SHORT',
        expectedLength: rule.minLength,
        actualLength: cleanedPhone.length
      };
    }
  
    if (cleanedPhone.length > rule.maxLength) {
      return {
        isValid: false,
        message: `Phone number is too long. Expected ${rule.maxLength} characters, got ${cleanedPhone.length}`,
        errorType: 'TOO_LONG',
        expectedLength: rule.maxLength,
        actualLength: cleanedPhone.length
      };
    }
  
    // Check pattern
    if (!rule.pattern.test(cleanedPhone)) {
      return {
        isValid: false,
        message: `Invalid phone number format for ${countryCode}. ${rule.description}`,
        errorType: 'INVALID_FORMAT',
        example: rule.example,
        description: rule.description
      };
    }
  
    // All validations passed
    return {
      isValid: true,
      message: 'Phone number is valid',
      cleanedNumber: cleanedPhone,
      countryCode: countryCode,
      description: rule.description
    };
  }
  
  /**
   * Gets validation rules for a specific country code
   * @param {string} countryCode - The country code to get rules for
   * @returns {Object|null} Validation rules or null if not found
   */
  function getPhoneValidationRules(countryCode) {
    return PHONE_VALIDATION_RULES[countryCode] || null;
  }
  
  /**
   * Gets all supported country codes
   * @returns {Array} Array of supported country codes
   */
  function getSupportedCountryCodes() {
    return Object.keys(PHONE_VALIDATION_RULES);
  }
  
  /**
   * Generates country code dropdown options based on settings
   * @param {Object} settings - The HyperOTP settings object
   * @returns {string} HTML string for country code dropdown options
   */
  function generateCountryCodeOptions(settings) {
    // Define all available countries with their codes and names
    const allCountries = [
      { code: '+91', name: 'India' },
      { code: '+90', name: 'Turkey' },
      { code: '+1', name: 'USA/Canada' },
      { code: '+44', name: 'UK' },
      { code: '+61', name: 'Australia' },
      { code: '+258', name: 'Mozambique' },
      { code: '+52', name: 'Mexico' },
      { code: '+86', name: 'China' },
      { code: '+66', name: 'Thailand' },
      { code: '+82', name: 'South Korea' },
      { code: '+370', name: 'Lithuania' },
      { code: '+973', name: 'Bahrain' },
      { code: '+48', name: 'Poland' },
      { code: '+386', name: 'Slovenia' },
      { code: '+60', name: 'Malaysia' },
      { code: '+971', name: 'UAE' },
      { code: '+966', name: 'Saudi Arabia' },
      { code: '+968', name: 'Oman' },
      { code: '+81', name: 'Japan' },
      { code: '+65', name: 'Singapore' },
      { code: '+886', name: 'Taiwan' },
      { code: '+31', name: 'Netherlands' },
      { code: '+84', name: 'Vietnam' },
      { code: '+852', name: 'Hong Kong' },
      { code: '+64', name: 'New Zealand' },
      { code: '+95', name: 'Myanmar' },
      { code: '+593', name: 'Ecuador' },
      { code: '+49', name: 'Germany' },
      { code: '+40', name: 'Romania' },
      { code: '+234', name: 'Nigeria' },
      { code: '+39', name: 'Italy' },
      { code: '+34', name: 'Spain' },
      { code: '+33', name: 'France' },
      { code: '+47', name: 'Norway' },
      { code: '+41', name: 'Switzerland' },
      { code: '+46', name: 'Sweden' },
      { code: '+63', name: 'Philippines' },
      { code: '+994', name: 'Azerbaijan' },
      { code: '+880', name: 'Bangladesh' },
      { code: '+227', name: 'Niger' },
      { code: '+213', name: 'Algeria' },
      { code: '+962', name: 'Jordan' },
      { code: '+855', name: 'Cambodia' },
      { code: '+972', name: 'Israel' },
      { code: '+974', name: 'Qatar' },
      { code: '+381', name: 'Serbia' }
    ];
  
    // If settings is not available or countryCode is "ALL", show all countries
    if (!settings || !settings.countryCode || settings.countryCode === 'ALL') {
      return allCountries.map(country =>
        `<option value="${country.code}" data-country="${country.name}" ${country.code === '+91' ? 'selected' : ''}>${country.code} ${country.name}</option>`
      ).join('');
    }
  
    // If specific country is set, show only that country
    const countryCodeMap = {
      'IN': '+91',
      'TR': '+90',
      'US': '+1',
      'CA': '+1',
      'GB': '+44',
      'AU': '+61',
      'MZ': '+258',
      'MX': '+52',
      'CN': '+86',
      'TH': '+66',
      'KR': '+82',
      'LT': '+370',
      'BH': '+973',
      'PL': '+48',
      'SI': '+386',
      'MY': '+60',
      'AE': '+971',
      'SA': '+966',
      'OM': '+968',
      'JP': '+81',
      'SG': '+65',
      'TW': '+886',
      'NL': '+31',
      'VN': '+84',
      'HK': '+852',
      'NZ': '+64',
      'MM': '+95',
      'EC': '+593',
      'DE': '+49',
      'RO': '+40',
      'NG': '+234',
      'IT': '+39',
      'ES': '+34',
      'FR': '+33',
      'NO': '+47',
      'CH': '+41',
      'SE': '+46',
      'PH': '+63',
      'AZ': '+994',
      'BD': '+880',
      'NE': '+227',
      'DZ': '+213',
      'JO': '+962',
      'KH': '+855',
      'IL': '+972',
      'QA': '+974',
      'RS': '+381'
    };
  
    const phoneCode = countryCodeMap[settings.countryCode];
    if (phoneCode) {
      const country = allCountries.find(c => c.code === phoneCode);
      if (country) {
        return `<option value="${country.code}" data-country="${country.name}" selected>${country.code} ${country.name}</option>`;
      }
    }
  
    // Fallback to India if country code mapping fails
    return `<option value="+91" data-country="India" selected>+91 India</option>`;
  }
  
  /**
   * Formats a phone number for display
   * @param {string} phoneNumber - The phone number to format
   * @param {string} countryCode - The country code
   * @returns {string} Formatted phone number
   */
  function formatPhoneNumberForDisplay(phoneNumber, countryCode) {
    if (!phoneNumber || !countryCode) return phoneNumber;
  
    const cleaned = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
    // Format based on country code
    switch (countryCode) {
      case '+91': // India: +91 XXXXX XXXXX
        if (cleaned.startsWith('+91') && cleaned.length === 13) {
          return cleaned.slice(0, 3) + ' ' + cleaned.slice(3, 8) + ' ' + cleaned.slice(8);
        }
        break;
      case '+1': // US/Canada: +1 XXX XXX XXXX
        if (cleaned.startsWith('+1') && cleaned.length === 12) {
          return cleaned.slice(0, 2) + ' ' + cleaned.slice(2, 5) + ' ' + cleaned.slice(5, 8) + ' ' + cleaned.slice(8);
        }
        break;
      case '+44': // UK: +44 XXXX XXXXXX
        if (cleaned.startsWith('+44') && cleaned.length === 13) {
          return cleaned.slice(0, 3) + ' ' + cleaned.slice(3, 7) + ' ' + cleaned.slice(7);
        }
        break;
      case '+86': // China: +86 XXX XXXX XXXX
        if (cleaned.startsWith('+86') && cleaned.length === 14) {
          return cleaned.slice(0, 3) + ' ' + cleaned.slice(3, 6) + ' ' + cleaned.slice(6, 10) + ' ' + cleaned.slice(10);
        }
        break;
    }
  
    return phoneNumber; // Return original if no specific formatting
  }
  
  /**
   * Extracts country code from a phone number
   * @param {string} phoneNumber - The phone number
   * @returns {string|null} Country code or null if not found
   */
  function extractCountryCode(phoneNumber) {
    if (!phoneNumber || typeof phoneNumber !== 'string') return null;
  
    const cleaned = phoneNumber.replace(/[\s\-\(\)]/g, '');
  
    // Check for supported country codes (longest first to avoid conflicts)
    const supportedCodes = getSupportedCountryCodes().sort((a, b) => b.length - a.length);
  
    for (const code of supportedCodes) {
      if (cleaned.startsWith(code)) {
        return code;
      }
    }
  
    return null;
  }
  
  /**
   * Validates and formats a phone number for a specific country
   * @param {string} phoneNumber - The phone number to validate
   * @param {string} countryCode - The country code
   * @returns {Object} Result with validation status and formatted number
   */
  function validateAndFormatPhone(phoneNumber, countryCode) {
    const validation = validatePhoneNumber(phoneNumber, countryCode);
  
    if (!validation.isValid) {
      return validation;
    }
  
    return {
      ...validation,
      formattedNumber: formatPhoneNumberForDisplay(validation.cleanedNumber, countryCode)
    };
  }
  
  /**
   * Gets a user-friendly error message for phone validation
   * @param {Object} validationResult - The validation result object
   * @returns {string} User-friendly error message
   */
  function getPhoneValidationErrorMessage(validationResult) {
    if (validationResult.isValid) return '';
  
    switch (validationResult.errorType) {
      case 'INVALID_INPUT':
        return 'Please enter a valid phone number.';
      case 'INVALID_COUNTRY_CODE':
        return 'Please select a valid country code.';
      case 'UNSUPPORTED_COUNTRY':
        return `Country code ${validationResult.message.split(' ')[2]} is not supported.`;
      case 'WRONG_COUNTRY_CODE':
        return validationResult.message;
      case 'TOO_SHORT':
        return `Phone number is too short. Please enter ${validationResult.expectedLength - validationResult.actualLength} more digit(s).`;
      case 'TOO_LONG':
        return `Phone number is too long. Please remove ${validationResult.actualLength - validationResult.expectedLength} digit(s).`;
      case 'INVALID_FORMAT':
        return validationResult.message;
      default:
        return 'Please enter a valid phone number.';
    }
  }
  
  /**
   * Validates phone number in real-time and provides feedback
   * @param {string} phoneNumber - The phone number to validate
   * @param {string} countryCode - The country code
   * @param {Function} onValidationChange - Callback function for validation changes
   */
  function validatePhoneNumberRealTime(phoneNumber, countryCode, onValidationChange) {
    const validation = validatePhoneNumber(phoneNumber, countryCode);
  
    if (onValidationChange && typeof onValidationChange === 'function') {
      onValidationChange(validation);
    }
  
    return validation;
  }
  
  /**
   * Creates a phone input with real-time validation
   * @param {Object} options - Configuration options
   * @returns {Object} Phone input object with methods
   */
  function createPhoneInput(options = {}) {
    const {
      countryCode = '+91',
      placeholder = 'Phone Number',
      onValidationChange = null,
      onCountryChange = null
    } = options;
  
    let currentCountryCode = countryCode;
    let currentPhoneNumber = '';
  
    return {
      /**
       * Sets the country code
       * @param {string} code - The country code
       */
      setCountryCode(code) {
        currentCountryCode = code;
        if (onCountryChange) onCountryChange(code);
        this.validate();
      },
  
      /**
       * Sets the phone number
       * @param {string} number - The phone number
       */
      setPhoneNumber(number) {
        currentPhoneNumber = number;
        this.validate();
      },
  
      /**
       * Validates the current phone number
       * @returns {Object} Validation result
       */
      validate() {
        return validatePhoneNumberRealTime(currentPhoneNumber, currentCountryCode, onValidationChange);
      },
  
      /**
       * Gets the current country code
       * @returns {string} Current country code
       */
      getCountryCode() {
        return currentCountryCode;
      },
  
      /**
       * Gets the current phone number
       * @returns {string} Current phone number
       */
      getPhoneNumber() {
        return currentPhoneNumber;
      },
  
      /**
       * Gets the full formatted phone number
       * @returns {string} Formatted phone number
       */
      getFullNumber() {
        const validation = this.validate();
        return validation.isValid ? validation.cleanedNumber : currentPhoneNumber;
      }
    };
  }
  
  /**
   * SECTION: OTP Form Handler
   * Manages the OTP form submission, verification, and user registration process
   * @param {HTMLFormElement} form - The OTP form element
   * @param {HTMLElement} otpContainer - The container element for the OTP UI
   */
  function attachOtpFormHandler(form, otpContainer) {
    const stepInput = form.querySelector('input[name="step"]');
    const identifierInput = form.querySelector('input[name="identifier"]');
    const countryCodeSelect = form.querySelector('#country-code');
    const otpInputWrapper = form.querySelector("#otp-input-wrapper");
    const otpInput = form.querySelector('input[name="otp"]');
    const nameInputWrapper = form.querySelector("#name-input-wrapper");
    const emailInputWrapper = form.querySelector("#email-input-wrapper");
    const firstNameInput = form.querySelector('input[name="first_name"]');
    const lastNameInput = form.querySelector('input[name="last_name"]');
    const emailInput = form.querySelector('input[name="email"]');
    const messageBox = document.getElementById("otp-message");
    const submitButton = form.querySelector("button[type='submit']");
  
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
  
      // Fetch settings if not already loaded
      if (!window.hyperOTPSettings) {
        await fetchHyperOTPSettings();
      }
  
      const step = stepInput ? stepInput.value : "send";
      let identifier = identifierInput ? identifierInput.value.trim() : "";
      let countryCode = countryCodeSelect ? countryCodeSelect.value : "+91"; // Default to India if no selection
      // Remove all spaces from identifier before any further processing (for phone only)
      if (identifier && !identifier.includes("@")) {
        identifier = identifier.replace(/\s+/g, '');
      }
      // Only concatenate if not email and not already has country code
      if (identifier && countryCode && !identifier.startsWith("+") && !identifier.includes("@")) {
        identifier = countryCode + identifier;
      }
      const otp = otpInput?.value?.trim();
  
      // Enhanced phone validation using the new validation system
      if (!identifier) {
        if (messageBox) {
          messageBox.style.color = "red";
          messageBox.innerText = "Please enter a phone number.";
        }
        return;
      }
  
      // Phone validation (only for phone, not email)
      if (!identifier.includes("@")) {
        // Extract country code from phone number if it starts with +
        let extractedCountryCode = countryCode;
        if (identifier.startsWith('+')) {
          // Try to extract country code from the phone number
          const extracted = extractCountryCodeFromPhone(identifier);
          if (extracted) {
            extractedCountryCode = extracted;
          }
        }
  
        // If no country code is available, use the one from dropdown
        if (!extractedCountryCode && countryCode) {
          extractedCountryCode = countryCode;
        }
  
        // If still no country code, provide a helpful error
        if (!extractedCountryCode) {
          if (messageBox) {
            messageBox.style.color = "red";
            messageBox.innerText = "Please select a country code from the dropdown or enter a complete phone number with country code";
          }
          return;
        }
  
        const validation = validatePhoneNumber(identifier, extractedCountryCode);
  
        if (!validation.isValid) {
          if (messageBox) {
            messageBox.style.color = "red";
            messageBox.innerText = validation.message;
          }
          return;
        }
  
        // Use the cleaned number for further processing
        identifier = validation.cleanedNumber;
      }
  
      if (step === "send") {
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="otp-spinner"></span>';
        const res = await fetch("/apps/hyperotp", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ phone: identifier, step: "send" })
        });
        const result = await res.json();
        // console.log("[OTP]", result.otp);
        // console.log("[SEND OTP RESPONSE]", result);
        submitButton.disabled = false;
  
        if (result.success) {
          if (messageBox) {
            messageBox.innerText = result.message || "OTP sent successfully.";
            messageBox.style.color = "green";
          }
          // Get enabled social logins and check if OTP form should be shown
          const { google, facebook } = getEnabledSocialLogins();
          const showSocialDivider = google || facebook;
          const showOTPForm = shouldShowOTPForm();
          const showEmailPassword = shouldShowEmailPasswordLogin();
  
          if (!showOTPForm) {
            // If OTP form should not be shown, just show social buttons and email password if enabled
            otpContainer.innerHTML = `
              <style>
                // ... existing styles ...
              </style>
              <h2 class="otp-title">${getLoginHeaderText()}</h2>
              <div id="otp-message" style="margin-bottom: 1rem; color: green;"></div>
              ${generateSocialButtonsHTML()}
              ${showEmailPassword ? `<button type="button" class="otp-email-btn">Login with Email & Password</button>` : ''}
            `;
            return;
          }
  
          // Custom OTP UI for verify step
          const showEmailPassword2 = shouldShowEmailPasswordLogin();
          otpContainer.innerHTML = `
              <style>
                .otp-verify-title { font-family: Inter, sans-serif; font-size: 30px; font-weight: 700; text-align: center; margin-top: 0; margin-bottom: 15px; }
                .otp-verify-desc { 
                  text-align: left; 
                  color: #616161; 
                  margin-bottom: -11px; 
                  font-size: 15px; 
                  font-family: 'Inter', Inter, sans-serif; 
                  font-weight: 400; 
                  letter-spacing: 0; 
                  line-height: 1.5;
                }
                .otp-verify-row { display: flex; align-items: center; justify-content: flex-start; gap: 8px; margin-bottom: 1.2rem; }
                .otp-verify-in { 
                 text-align: left; color: #000; margin-bottom: 0.8rem; font-weight: 700; font-size: 16px; font-family: Inter, sans-serif;  }
                .otp-verify-change { font-family: Inter, sans-serif; font-size: 18px;  font-weight: 450; color: #005BD3; text-decoration: underline; cursor: pointer;  }
                .otp-verify-form-row { display: flex; flex-direction: row; align-items: left; gap: 4px; width: 100%; margin-bottom: 0.8rem; }
                .otp-verify-input { flex: 1; height: 45px; margin-top: 0px; padding: 0 8px; border: 0.66px solid #8A8A8A; background: #FDFDFD; font-size: 24px; color: #303030; font-family: Inter, sans-serif; border-radius: 8px; outline: none; text-align: center; box-shadow: none !important; letter-spacing: 0.8em; max-width: 100%; box-sizing: border-box; }
                .otp-verify-input::placeholder { letter-spacing: normal; font-size: 20px; }
                .otp-verify-input:focus { background: #fff; border: 0.66px solid #8A8A8A; box-shadow: none !important; outline: none !important; }
                .otp-verify-btn {
                width: 100%;
        border-radius: 8px;
        height: 48px;
        font-size: 18px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: background 0.2s;
                 }
                .otp-verify-bottom-row { display: flex; align-items: left; gap: 8px;  }
                .otp-verify-bottom-label { font-family: Inter, sans-serif; padding-top: 13px; font-size: 13px; font-weight: 650; color: #000; letter-spacing: 0px; line-height: 20px; }
                .otp-verify-change-label {
                  text-align: left;
                  color: #222;
                  margin-bottom: 12px;
                  font-size: 15px;
                  font-family: 'Inter', Inter, sans-serif;
                  font-weight: 650;
                  letter-spacing: 0;
                  line-height: 20px;
                  padding: 6px 0;
                }
                .otp-verify-bottom-link { font-family: Inter, sans-serif; padding-top: 10px; font-size: 14px; font-weight: 650; color: #00527C; text-decoration: underline; cursor: pointer; }
                .otp-divider { display: flex; align-items: center; gap: 16px; width: 100%; margin: 5px 2px 7px 0; }
                .otp-divider-hr { flex: 1; border: none; border-top: 1px solid #8A8A8A; height: 1px; background: none; margin: 0; }
                .otp-divider-text { color: #000; font-family: 'SF Pro Text', Inter, sans-serif; font-size: 12px; font-weight: 600; }
                .otp-social-row { display: flex; gap: 8px; width: 100%; margin: -4px 0 8px 0; }
                .otp-social-btn { flex: 1; display: flex; align-items: center; justify-content: center; background: #fff; border: 1px solid #E3E3E3; border-radius: 8px; height: 52px; cursor: pointer; transition: border 0.2s; }
                .otp-social-btn:focus { outline: none; border: 1.5px solid #8A8A8A; }
                .otp-social-btn img { width: 28px; height: 28px; display: block; }
                .otp-social-btn span { margin-left: 8px; font-size: 16px; color: #303030; font-family: Inter, sans-serif; }
                .otp-email-btn {
                          width: 100%;       
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 8px;
          line-height: 45px; 
          font-size: 18px;
          font-family: Inter, sans-serif;
          font-weight:500;
          cursor: pointer;
          color: #303030;
          transition: background 0.2s, border 0.2s; 
                  }
                .otp-email-btn:focus { outline: none; border: 1.5px solid #8A8A8A; }
                .otp-spinner {
                  display: inline-block;
                  width: 22px;
                  height: 22px;
                  border: 3px solid #fff;
                  border-radius: 50%;
                  border-top: 3px solid #1A1A1A;
                  animation: otp-spin 0.7s linear infinite;
                  vertical-align: middle;
                  margin-right: 8px;
                }
                @keyframes otp-spin {
                  0% { transform: rotate(0deg);}
                  100% { transform: rotate(360deg);}
                }
              </style>
              <h2 class="otp-verify-title">Enter OTP</h2>
              <div id="otp-message" style="margin-bottom: 1rem; color: red;"></div>
              <div class="otp-verify-desc"><b>OTP sent successfully on Phone, please enter it below</b></div>
              
               <div class="otp-verify-bottom-row">
                  <p class="otp-verify-change-label">${getCountryNameFromPhone(identifier)} ${formatPhoneDisplay(identifier)}  <a href="#" id="otp-change-link" class="otp-verify-bottom-link">Change</a></p>
                 
              </div>
              <form id="otp-form">
                <input type="hidden" name="step" value="verify" />
                <input type="hidden" name="identifier" value="${identifier}" />
                <div id="otp-input-wrapper" class="otp-verify-form-row">
                  <input name="otp" placeholder="Enter OTP" class="otp-verify-input" />
                </div>
                <div id="name-input-wrapper" class="otp-verify-form-row" style="display:none;">
                  <input name="first_name" placeholder="First Name" class="otp-verify-input" style="flex:1;" />
                  <input name="last_name" placeholder="Last Name" class="otp-verify-input" style="flex:1;" />
                </div>
                <div id="email-input-wrapper" class="otp-verify-form-row" style="display:none;">
                  <input name="email" placeholder="Email" class="otp-verify-input" style="flex:1;" />
                </div>
                <button type="submit" class="otp-verify-btn">Submit OTP</button>
                <div class="otp-verify-bottom-row">
                  <span class="otp-verify-bottom-label">OTP not Received?</span>
                  <a href="#" id="otp-resend-link" class="otp-verify-bottom-link">Resend OTP</a>
                </div>
              </div>
            </form>
              ${showSocialDivider ? `
                <div class="otp-divider">
                  <hr class="otp-divider-hr" />
                  <span class="otp-divider-text">OR</span>
                  <hr class="otp-divider-hr" />
                </div>
                ${generateSocialButtonsHTML()}
              ` : ''}
              ${showEmailPassword2 ? `<button type="button" class="otp-email-btn">Login with Email & Password</button>` : ''}
          `;
          // Re-attach main handler to new OTP form
          const newForm = otpContainer.querySelector('#otp-form');
          attachOtpFormHandler(newForm, otpContainer);
          // Add OTP input restrictions: only 4 digits, numeric only
          if (newForm.querySelector('input[name="otp"]')) {
            const otpInput = newForm.querySelector('input[name="otp"]');
            otpInput.setAttribute('maxlength', '4');
            otpInput.setAttribute('inputmode', 'numeric');
            otpInput.setAttribute('pattern', '\\d{4}');
            otpInput.addEventListener('input', function (e) {
              // Remove non-numeric characters
              let val = otpInput.value.replace(/[^0-9]/g, '');
              // Limit to 4 digits
              if (val.length > 4) val = val.slice(0, 4);
              otpInput.value = val;
            });
          }
          // Change and Resend OTP links
          otpContainer.querySelector('#otp-change-link').addEventListener('click', (e) => {
            e.preventDefault();
            // Get the identifier (phone) from the hidden input
            const identifierValue = newForm.querySelector('input[name="identifier"]').value;
            // Extract country code and phone number for pre-filling
            const countryCode = extractCountryCodeFromPhone(identifierValue);
            const phoneNumber = countryCode ? identifierValue.replace(countryCode, "") : identifierValue;
            // Re-render the Get OTP form with the phone pre-filled and loading state
            renderInitialForm(otpContainer, { loadingSocial: true, prefillPhone: phoneNumber });
            fetchHyperOTPSettings().then(() => {
              renderInitialForm(otpContainer, { loadingSocial: false, prefillPhone: phoneNumber });
              const { google, facebook } = getEnabledSocialLogins();
              const showOTPForm = shouldShowOTPForm();
              const showEmailPassword = shouldShowEmailPasswordLogin();
              const googleButton = otpContainer.querySelector('.google-sso-btn');
              const facebookButton = otpContainer.querySelector('button:has(img[alt="Facebook"])');
              const emailButton = otpContainer.querySelector('.email-btn');
              const divider = otpContainer.querySelector('.divider');
              const otpFormElement = otpContainer.querySelector('#otp-form');
              if (googleButton) {
                if (google) {
                  googleButton.disabled = false;
                  googleButton.style.opacity = '1';
                } else {
                  googleButton.style.display = 'none';
                }
              }
              if (facebookButton) {
                if (facebook) {
                  facebookButton.disabled = false;
                  facebookButton.style.opacity = '1';
                } else {
                  facebookButton.style.display = 'none';
                }
              }
              if (emailButton) {
                if (showEmailPassword) {
                  emailButton.disabled = false;
                  emailButton.style.opacity = '1';
                } else {
                  emailButton.style.display = 'none';
                }
              }
              if (otpFormElement) {
                otpFormElement.style.display = showOTPForm ? 'block' : 'none';
              }
              if (divider && !google && !facebook && !showEmailPassword) {
                divider.style.display = 'none';
              }
              attachGoogleSSOHandlers();
              attachFacebookSSOHandlers();
            });
          });
          otpContainer.querySelector('#otp-resend-link').addEventListener('click', async (e) => {
            e.preventDefault();
            const resendLink = otpContainer.querySelector('#otp-resend-link');
            if (resendLink) {
              resendLink.innerHTML = '<span class="otp-spinner" style="display:inline-block;vertical-align:middle;min-width:22px;min-height:22px;"></span>';
              resendLink.style.pointerEvents = 'none';
            }
            // Get the identifier (phone) from the hidden input
            const identifierValue = newForm.querySelector('input[name="identifier"]').value;
            // Directly call the backend to resend OTP
            const messageBox = otpContainer.querySelector('#otp-message');
            try {
              const res = await fetch('/apps/hyperotp', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ phone: identifierValue, step: 'send' })
              });
              const result = await res.json();
              if (result.success) {
                if (messageBox) {
                  messageBox.style.color = 'green';
                  messageBox.innerText = result.message || 'OTP resent successfully.';
                }
              } else {
                if (messageBox) {
                  messageBox.style.color = 'red';
                  messageBox.innerText = result.error || 'Failed to resend OTP.';
                }
              }
            } catch (err) {
              if (messageBox) {
                messageBox.style.color = 'red';
                messageBox.innerText = 'Failed to resend OTP.';
              }
            } finally {
              if (resendLink) {
                resendLink.innerHTML = 'Resend OTP';
                resendLink.style.pointerEvents = '';
              }
            }
          });
  
          // Apply dynamic button colors and header text after OTP verification form is rendered
          updateButtonColors();
          updateHeaderText();
          return;
        } else {
          if (messageBox) {
            messageBox.innerText = result.error || "Failed to send OTP.";
            messageBox.style.color = "red";
          }
          submitButton.innerHTML = "Send OTP";
        }
      } else if (step === "verify" || step === "complete") {
        // Validate OTP input
        if (!otp || otp.length !== 4 || !/^[0-9]{4}$/.test(otp)) {
          if (messageBox) {
            messageBox.style.color = "red";
            messageBox.innerText = "Please enter a valid 4-digit OTP.";
          }
          return;
        }
        // If step is complete, validate email
        if (step === "complete") {
          if (!emailInput || !emailInput.value.trim()) {
            if (messageBox) {
              messageBox.style.color = "red";
              messageBox.innerText = "Please enter your email.";
            }
            return;
          }
        }
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="otp-spinner"></span>';
        // Prepare payload
        let payload = { phone: identifier, otp, step };
        if (step === "complete") payload.email = emailInput.value.trim();
        const res = await fetch("/apps/hyperotp", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result = await res.json();
        // console.log("[OTP VERIFY/COMPLETE RESPONSE]", result);
        submitButton.disabled = false;
  
        // Handle requireEmail response from backend
        if (result.requireEmail) {
          // Hide OTP input, show email input
          if (emailInputWrapper) emailInputWrapper.style.display = '';
          if (otpInputWrapper) otpInputWrapper.style.display = 'none';
          if (submitButton) submitButton.innerText = 'Continue';
          if (stepInput) stepInput.value = 'update_email';
          form.dataset.customerId = result.customerId;
          if (messageBox) {
            messageBox.style.color = 'red';
            messageBox.innerText = result.message || 'Please enter your email to continue.';
          }
          return;
        }
  
        // NEW: If new customer, show signup form (name/email)
        if (result.success && result.existingCustomer === false) {
          // Render a separate signup form for new customers
          otpContainer.style.background = '#fff';
          otpContainer.style.borderRadius = '16px';
          otpContainer.style.border = '1px solid #E3E3E3';
          otpContainer.style.boxShadow = '0px 3px 1px -1px rgba(26,26,26,0.07), inset 0px 1px 0px 0px rgba(204,204,204,0.5), inset 0px -1px 0px 0px rgba(0,0,0,0.17), inset -1px 0px 0px 0px rgba(0,0,0,0.13), inset 1px 0px 0px 0px rgba(0,0,0,0.13)';
          otpContainer.style.maxWidth = '484px';
          otpContainer.style.margin = '40px auto';
          otpContainer.style.padding = '40px 32px 32px 32px';
          otpContainer.style.display = 'flex';
          otpContainer.style.flexDirection = 'column';
          otpContainer.style.gap = '0';
          // Check registerFields setting
          const registerFields = (window.hyperOTPSettings && window.hyperOTPSettings.registerFields) ? window.hyperOTPSettings.registerFields : '';
          // Check acceptEnabled setting
          const acceptEnabled = (window.hyperOTPSettings && window.hyperOTPSettings.acceptEnabled) ? window.hyperOTPSettings.acceptEnabled : false;
          otpContainer.innerHTML = `
            <style>
              .signup-title {
                font-family: Inter, sans-serif;
                font-size: 30px;
                font-weight: 700;
                color: #000;
                margin-bottom: 0.5rem;
                text-align: left;
                letter-spacing: -0.3px;
                line-height: 40px;
              }
              .signup-desc {
                color: #616161;
                font-size: 14px;
                font-family: Inter, sans-serif;
                font-weight: 650;
                margin-bottom: 1.5rem;
                text-align: left;
                line-height: 1.43;
              }
              .signup-form-row {
                display: flex;
                flex-direction: column;
                gap: 4px;
                margin-bottom: 1.2rem;
              }
              .signup-label {
                font-family: Inter, sans-serif;
                font-size: 13px;
                font-weight: 450;
                color: #303030;
                margin-bottom: 2px;
                text-align: left;
              }
              .signup-input {
                height: 45px;
                padding: 0 16px;
                border: 1px solid #8A8A8A;
                background: #FDFDFD;
                font-size: 18px;
                color: #303030;
                font-family: Inter, sans-serif;
                border-radius: 8px;
                outline: none;
                transition: border 0.2s;
                box-shadow: none !important;
              }
              .signup-input:focus {
                border: 1px solid #8A8A8A;
                background: #fff;
                box-shadow: none !important;
                outline: none !important;
              }
              .signup-input[readonly] {
                background: #F5F5F5;
                color: #8A8A8A;
              }
              .signup-input::placeholder {
                color: #8A8A8A;
                font-size: 18px;
                font-family: Inter, sans-serif;
                opacity: 1;
              }
              .signup-btn {
                font-size: 18px;
                font-family: Inter, sans-serif;
                font-weight: 550;
                height: 52px;
                width: 100%;
                margin-top: 8px;
                cursor: pointer;
                border-radius: 8px;
                transition: background 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
  
                position: relative;
                overflow: hidden;
              }
              .signup-btn::after {
                content: '';
                position: absolute;
                left: 0; top: 0; right: 0; bottom: 0;
                background: linear-gradient(90deg,rgba(255,255,255,0.07) 88%,rgba(255,255,255,0.15) 100%);
                pointer-events: none;
                border-radius: 8px;
              }
              .signup-checkbox-wrapper {
                display: flex;
                align-items: flex-start;
                gap: 12px;
                cursor: pointer;
                margin-bottom: 8px;
              }
              .signup-checkbox {
                width: 18px;
                height: 18px;
                margin: 2px 0 0 0;
                accent-color: #1A1A1A;
                cursor: pointer;
              }
              .signup-checkbox-label {
                font-family: Inter, sans-serif;
                font-size: 14px;
                font-weight: 400;
                color: #303030;
                line-height: 1.43;
                text-align: left;
                cursor: pointer;
              }
              .otp-spinner {
                display: inline-block;
                width: 22px;
                height: 22px;
                border: 3px solid #fff;
                border-radius: 50%;
                border-top: 3px solid #1A1A1A;
                animation: otp-spin 0.7s linear infinite;
                vertical-align: middle;
                margin-right: 8px;
              }
              @keyframes otp-spin {
                0% { transform: rotate(0deg);}
                100% { transform: rotate(360deg);}
              }
            </style>
            <div class="signup-title">Contact Information</div>
            <div class="signup-desc">Please enter your email id to register and login</div>
            <form id="signup-form" autocomplete="off">
              ${registerFields === 'email' ? '' : `
              <div class="signup-form-row">
                <label class="signup-label" for="first_name">First name</label>
                <input name="first_name" id="first_name" placeholder="e.g John" class="signup-input" />
              </div>
              <div class="signup-form-row">
                <label class="signup-label" for="last_name">Last name</label>
                <input name="last_name" id="last_name" placeholder="e.g Doe" class="signup-input" />
              </div>
              `}
              <div class="signup-form-row">
                <label class="signup-label" for="email">Email Address *</label>
                <input name="email" id="email" placeholder="e.g name@domain.com" class="signup-input" type="email" required />
              </div>
              ${acceptEnabled ? `
              <div class="signup-form-row">
                <label class="signup-checkbox-wrapper">
                  <input type="checkbox" name="subscription" id="subscription" class="signup-checkbox" />
                  <span class="signup-checkbox-label">Subscribe to newsletter and promotional offers</span>
                </label>
              </div>
              ` : ''}
              <input type="hidden" name="phone" id="phone" value="${identifier}" />
              <button type="submit" class="signup-btn">Login</button>
            </form>
          `;
          // Attach handler for the new signup form
          const signupForm = otpContainer.querySelector('#signup-form');
          signupForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            const firstName = signupForm.querySelector('input[name="first_name"]')?.value.trim() || '';
            const lastName = signupForm.querySelector('input[name="last_name"]')?.value.trim() || '';
            const email = signupForm.querySelector('input[name="email"]')?.value.trim() || '';
            const phone = signupForm.querySelector('input[name="phone"]').value.trim();
            const subscription = signupForm.querySelector('input[name="subscription"]')?.checked || false;
            const submitBtn = signupForm.querySelector('button[type="submit"]');
            // Only require email
            if (!email) {
              alert('Please enter your email.');
              return;
            }
            submitBtn.disabled = true;
            submitBtn.innerHTML = '<span class="otp-spinner"></span>';
            const res = await fetch('/apps/hyperotp', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                phone,
                email,
                first_name: registerFields !== 'email' ? firstName : '',
                last_name: registerFields !== 'email' ? lastName : '',
                subscription,
                step: 'complete'
              })
            });
            const result = await res.json();
            submitBtn.disabled = false;
            if (result.success && result.email && result.password) {
              // Submit login form automatically with CAPTCHA
              const form = document.createElement('form');
              form.method = 'POST';
              form.action = '/account/login';
              const emailInput = document.createElement('input');
              emailInput.type = 'hidden';
              emailInput.name = 'customer[email]';
              emailInput.value = result.email;
              form.appendChild(emailInput);
              const passwordInput = document.createElement('input');
              passwordInput.type = 'hidden';
              passwordInput.name = 'customer[password]';
              passwordInput.value = result.password;
              form.appendChild(passwordInput);
              const formTypeInput = document.createElement('input');
              formTypeInput.type = 'hidden';
              formTypeInput.name = 'form_type';
              formTypeInput.value = 'customer_login';
              form.appendChild(formTypeInput);
              const urlParams = new URLSearchParams(window.location.search);
              const returnUrl = result.return_url || urlParams.get('return_url');
              if (returnUrl) {
                const returnInput = document.createElement('input');
                returnInput.type = 'hidden';
                returnInput.name = 'return_url';
                returnInput.value = returnUrl;
                form.appendChild(returnInput);
              }
              document.body.appendChild(form);
              if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
                window.Shopify.captcha.protect(form, () => { form.submit(); });
              } else {
                form.submit();
              }
              return;
            }
            if (result.error) {
              alert(result.error);
            } else {
              alert(result.message || 'Signup complete!');
            }
          });
  
          // Apply dynamic button colors and header text after signup form is rendered
          updateButtonColors();
          updateHeaderText();
          return;
        }
        // Success: login as usual
        if (result.success && result.email && result.password) {
          // Submit login form automatically with CAPTCHA
          const form = document.createElement('form');
          form.method = 'POST';
          form.action = '/account/login';
          const emailInputHidden = document.createElement('input');
          emailInputHidden.type = 'hidden';
          emailInputHidden.name = 'customer[email]';
          emailInputHidden.value = result.email;
          form.appendChild(emailInputHidden);
          const passwordInput = document.createElement('input');
          passwordInput.type = 'hidden';
          passwordInput.name = 'customer[password]';
          passwordInput.value = result.password;
          form.appendChild(passwordInput);
          const formTypeInput = document.createElement('input');
          formTypeInput.type = 'hidden';
          formTypeInput.name = 'form_type';
          formTypeInput.value = 'customer_login';
          form.appendChild(formTypeInput);
          const urlParams = new URLSearchParams(window.location.search);
          const returnUrl = result.return_url || urlParams.get('return_url');
          if (returnUrl) {
            const returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_url';
            returnInput.value = returnUrl;
            form.appendChild(returnInput);
          }
          document.body.appendChild(form);
          if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
            window.Shopify.captcha.protect(form, () => { form.submit(); });
          } else {
            form.submit();
          }
          return;
        }
        if (result.error) {
          if (messageBox) {
            messageBox.style.color = 'red';
            messageBox.innerText = result.error;
          }
        } else if (result.message) {
          if (messageBox) {
            messageBox.style.color = 'green';
            messageBox.innerText = result.message;
          }
        }
        submitButton.innerHTML = step === 'complete' ? 'Continue' : 'Submit OTP';
        return;
      } else if (step === "update_email") {
        // On submit, if step is update_email, send correct payload
        if (!emailInput || !emailInput.value.trim()) {
          if (messageBox) {
            messageBox.style.color = "red";
            messageBox.innerText = "Please enter your email.";
          }
          return;
        }
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="otp-spinner"></span>';
        let payload = {
          step: "update_email",
          customerId: form.dataset.customerId,
          email: emailInput.value.trim(),
          phone: identifier
        };
        const res2 = await fetch("/apps/hyperotp", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const result2 = await res2.json();
        submitButton.disabled = false;
        // Handle login as normal
        if (result2.success && result2.email && result2.password) {
          // Submit login form automatically with CAPTCHA
          const formEl = document.createElement('form');
          formEl.method = 'POST';
          formEl.action = '/account/login';
          const emailInputHidden = document.createElement('input');
          emailInputHidden.type = 'hidden';
          emailInputHidden.name = 'customer[email]';
          emailInputHidden.value = result2.email;
          formEl.appendChild(emailInputHidden);
          const passwordInput = document.createElement('input');
          passwordInput.type = 'hidden';
          passwordInput.name = 'customer[password]';
          passwordInput.value = result2.password;
          formEl.appendChild(passwordInput);
          const formTypeInput = document.createElement('input');
          formTypeInput.type = 'hidden';
          formTypeInput.name = 'form_type';
          formTypeInput.value = 'customer_login';
          formEl.appendChild(formTypeInput);
          const urlParams = new URLSearchParams(window.location.search);
          const returnUrl = result2.return_url || urlParams.get('return_url');
          if (returnUrl) {
            const returnInput = document.createElement('input');
            returnInput.type = 'hidden';
            returnInput.name = 'return_url';
            returnInput.value = returnUrl;
            formEl.appendChild(returnInput);
          }
          document.body.appendChild(formEl);
          if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
            window.Shopify.captcha.protect(formEl, () => { formEl.submit(); });
          } else {
            formEl.submit();
          }
          return;
        }
        if (result2.error) {
          if (messageBox) {
            messageBox.style.color = 'red';
            messageBox.innerText = result2.error;
          }
        } else if (result2.message) {
          if (messageBox) {
            messageBox.style.color = 'green';
            messageBox.innerText = result2.message;
          }
        }
        submitButton.innerHTML = 'Continue';
        return;
      }
    });
  }
  
  /**
   * SECTION: Helper Functions
   * Utility functions for formatting and validation
   */
  
  /**
   * Formats phone numbers for display based on country code
   * @param {string} identifier - The phone number to format
   * @returns {string} Formatted phone number
   */
  function formatPhoneDisplay(identifier) {
    // Use the new validation system for better formatting
    if (typeof identifier !== 'string') return identifier;
  
    // Extract country code from the phone number
    const countryCode = extractCountryCode(identifier);
    if (!countryCode) return identifier;
  
    // Use the new formatting function
    return formatPhoneNumberForDisplay(identifier, countryCode);
  }
  
  /**
   * SECTION: SSO Management
   * Handles Single Sign-On (SSO) functionality for Google and Facebook
   */
  
  /**
   * Manages SSO popup state to prevent multiple popups
   */
  function isSSOPopupOpened() {
    return window._ssoPopupOpened || sessionStorage.getItem('ssoPopupOpened') === 'true';
  }
  
  function setSSOPopupOpened(val) {
    window._ssoPopupOpened = val;
    sessionStorage.setItem('ssoPopupOpened', val ? 'true' : 'false');
  }
  
  // Reset SSO popup state on page load
  setSSOPopupOpened(false);
  
  /**
   * SECTION: Google SSO Integration
   * Handles Google Single Sign-On functionality
   */
  
  /**
   * Opens the Google SSO popup window
   */
function openGoogleSSOPopup() {
    if (isSSOPopupOpened()) {
      return;
    }
    setSSOPopupOpened(true);
    var shop = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'yourshop.myshopify.com';
    var urlParams = new URLSearchParams(window.location.search);
    var returnUrl = urlParams.get('return_url');
    var popupUrl = 'https://hyperotp.onrender.com/app/authgoogle?shop=' + encodeURIComponent(shop);
    if (returnUrl) {
      popupUrl += '&return_url=' + encodeURIComponent(returnUrl);
    }
    var popup = window.open(popupUrl, 'googleSSO', 'width=500,height=600');

    // Monitor popup close event
    var checkClosed = setInterval(function () {
      if (popup.closed) {
        setSSOPopupOpened(false);
        clearInterval(checkClosed);
      }
    }, 1000);
  }
  
  /**
   * Attaches click handlers to Google SSO buttons
   * Handles both static and dynamically added buttons
   */
  function attachGoogleSSOHandlers() {
    document.querySelectorAll('.google-sso-btn').forEach(btn => {
      btn.removeEventListener('click', btn._googleSSOHandler);
      btn._googleSSOHandler = function (event) {
        event.preventDefault();
        openGoogleSSOPopup();
        return false;
      };
      btn.addEventListener('click', btn._googleSSOHandler);
    });
  }
  
  // Initial attach for Google SSO
  attachGoogleSSOHandlers();
  
  // Watch for dynamic UI changes
  const observer = new MutationObserver(() => {
    attachGoogleSSOHandlers();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  
  /**
   * SECTION: Facebook SSO Integration
   * Handles Facebook Single Sign-On functionality
   */
  
  /**
   * Opens the Facebook SSO popup window
   */
function openFacebookSSOPopup() {
    if (isSSOPopupOpened()) {
      return;
    }
    setSSOPopupOpened(true);
    var shop = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'yourshop.myshopify.com';
    var popup = window.open('https://hyperotp.onrender.com/app/authfacebook?shop=' + encodeURIComponent(shop), 'facebookSSO', 'width=500,height=600');

    // Monitor popup close event
    var checkClosed = setInterval(function () {
      if (popup.closed) {
        setSSOPopupOpened(false);
        clearInterval(checkClosed);
      }
    }, 1000);
  }
  
  /**
   * Attaches click handlers to Facebook SSO buttons
   * Handles both static and dynamically added buttons
   */
  function attachFacebookSSOHandlers() {
    // Handle buttons with facebook-sso-btn class
    document.querySelectorAll('.facebook-sso-btn').forEach(btn => {
      // Remove any old onclick attributes
      btn.removeAttribute('onclick');
      btn.removeEventListener('click', btn._facebookSSOHandler);
      btn._facebookSSOHandler = function (event) {
        event.preventDefault();
        openFacebookSSOPopup();
        return false;
      };
      btn.addEventListener('click', btn._facebookSSOHandler);
    });
  
    // Also handle generic social buttons with Facebook images (fallback)
    document.querySelectorAll('.social-btn').forEach(btn => {
      if (btn.querySelector('img[alt="Facebook"]')) {
        // Remove any old onclick attributes
        btn.removeAttribute('onclick');
        btn.removeEventListener('click', btn._facebookSSOHandler);
        btn._facebookSSOHandler = function (event) {
        event.preventDefault();
          openFacebookSSOPopup();
          return false;
        };
        btn.addEventListener('click', btn._facebookSSOHandler);
      }
    });
  }
  
  // Initial attach for Facebook SSO
  attachFacebookSSOHandlers();
  
  // Watch for dynamic UI changes
  const fbObserver = new MutationObserver(() => {
    attachFacebookSSOHandlers();
  });
  fbObserver.observe(document.body, { childList: true, subtree: true });
  
  /**
   * SECTION: SSO Message Handler
   * Processes messages from SSO popups and handles login
   */
  window.addEventListener("message", function (event) {
    if (event.data && event.data.type === "shopify-sso-login") {
      setSSOPopupOpened(false); // Reset flag after successful login
  
      // Create and submit login form
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/account/login';
  
      // Add login credentials
      const emailInput = document.createElement('input');
      emailInput.type = 'hidden';
      emailInput.name = 'customer[email]';
      emailInput.value = event.data.email;
      form.appendChild(emailInput);
  
      const passwordInput = document.createElement('input');
      passwordInput.type = 'hidden';
      passwordInput.name = 'customer[password]';
      passwordInput.value = event.data.password;
      form.appendChild(passwordInput);
  
      // Add form type for Shopify CAPTCHA
      const formTypeInput = document.createElement('input');
      formTypeInput.type = 'hidden';
      formTypeInput.name = 'form_type';
      formTypeInput.value = 'customer_login';
      form.appendChild(formTypeInput);
  
      // Use return_url from backend if present, else from query param
      const urlParams = new URLSearchParams(window.location.search);
      const returnUrl = event.data.return_url || urlParams.get('return_url');
      if (returnUrl) {
        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_url';
        returnInput.value = returnUrl;
        form.appendChild(returnInput);
      }
  
      // Submit form with CAPTCHA protection if available
      document.body.appendChild(form);
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form, () => { form.submit(); });
      } else {
        form.submit();
      }
    }
  });
  
  /**
   * Auto-login via query parameters (mobile/in-app fallback)
   * If sso_email and sso_password are present in URL, submit /account/login with CAPTCHA protection
   */
  function autoLoginFromQueryParams() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const ssoEmail = urlParams.get('sso_email');
      const ssoPassword = urlParams.get('sso_password');
      const returnUrl = urlParams.get('return_url');

      if (!ssoEmail || !ssoPassword) return;
  
      // Use the same logic as the postMessage handler
      setSSOPopupOpened(false); // Reset flag after successful login
  
      // Create and submit login form
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = '/account/login';
  
      // Add login credentials
      const emailInput = document.createElement('input');
      emailInput.type = 'hidden';
      emailInput.name = 'customer[email]';
      emailInput.value = ssoEmail;
      form.appendChild(emailInput);
  
      const passwordInput = document.createElement('input');
      passwordInput.type = 'hidden';
      passwordInput.name = 'customer[password]';
      passwordInput.value = ssoPassword;
      form.appendChild(passwordInput);
  
      // Add form type for Shopify CAPTCHA
      const formTypeInput = document.createElement('input');
      formTypeInput.type = 'hidden';
      formTypeInput.name = 'form_type';
      formTypeInput.value = 'customer_login';
      form.appendChild(formTypeInput);
  
      // Use return_url from URL params
      if (returnUrl) {
        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_url';
        returnInput.value = returnUrl;
        form.appendChild(returnInput);
      }
  
      // Submit form with CAPTCHA protection if available
      document.body.appendChild(form);
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form, () => { form.submit(); });
      } else {
        form.submit();
      }
    } catch (e) {
      console.error('[SSO] Auto-login failed', e);
    }
  }
  
  // Call the function when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoLoginFromQueryParams);
  } else {
    autoLoginFromQueryParams();
  }
  
  /**
   * Renders the initial login/signup form with optional loading state for social buttons
   * @param {HTMLElement} otpContainer - The container to render into
   * @param {Object} options - { loadingSocial: boolean, prefillPhone: string }
   */
  function renderInitialForm(otpContainer, options = {}) {
    const { loadingSocial = false, prefillPhone = '' } = options;
    otpContainer.innerHTML = `
      <style>
        .otp-login-container h2 { margin-top: 10px; margin-bottom: 10px; font-size: 30px; font-weight: 700; letter-spacing: -0.3px; }
        .input-group {
          display: flex;
          align-items: center;
          border: 1px solid #ccc;
          border-radius: 8px;
          padding: 0 12px;
          background: #fff;
          margin-bottom: 8px;
          height: 48px;
        }
        .input-group select {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          font-size: 18px;
          font-weight: 500;
          font-family: 'Inter', Inter, sans-serif;
          color: #222;
          margin: 0;
          padding: 0;
          width: 65px;
          min-width: 65px;
          flex-shrink: 0;
        }
        .input-group input {
          background: transparent !important;
          border: none !important;
          box-shadow: none !important;
          outline: none !important;
          font-size: 18px;
          font-weight: 500;
          font-family: 'Inter', Inter, sans-serif;
          color: #222;
          margin: 0;
          padding: 0;
          flex: 1;
        }
        .otp-btn {
          width: 100%;
          border-radius: 8px;
          height: 48px;
          font-size: 18px;
          margin-bottom: 10px;
          cursor: pointer;
          transition: background 0.2s;
        }
        .divider { display: flex; align-items: center; text-align: center; margin-bottom: 12px; margin-top: 6px; }
        .divider::before, .divider::after { content: ''; flex: 1; border-bottom: 1.5px solid #ddd; }
        .divider:not(:empty)::before { margin-right: .75em; }
        .divider:not(:empty)::after { margin-left: .75em; }
        .social-row {
          display: flex;
          gap: 16px;
          margin-bottom: 8px;
        }
        .social-btn {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 8px;
          height: 48px;
          width: 100%;
          cursor: pointer;
          font-size: 1.1rem;
          transition: background 0.2s, border 0.2s;
          padding: 0;
        }
        .social-btn:disabled {
          cursor: not-allowed;
        }
        .social-btn:hover {
          background: #f0f0f0;
          border-color: #bbb;
        }
        .social-btn img {
          width: 24px;
          height: 24px;
          display: block;
        }
        .email-btn {
          width: 100%;       
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 8px;
          line-height: 45px; 
          font-size: 18px;
          font-family: Inter, sans-serif;
          font-weight:500;
          cursor: pointer;
          color: #303030;
          transition: background 0.2s, border 0.2s; 
        }
        .email-btn:hover { background: #f0f0f0; border-color: #bbb; }
        .otp-spinner {
          display: inline-block;
          width: 22px;
          height: 22px;
          border: 3px solid #fff;
          border-radius: 50%;
          border-top: 3px solid #1A1A1A;
          animation: otp-spin 0.7s linear infinite;
          vertical-align: middle;
          margin-right: 8px;
        }
        @keyframes otp-spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      </style>
      <h2>${getLoginHeaderText()} </h2>   
      <div id="otp-message" style="margin-bottom: 1rem; color: green;"></div>
      <form id="otp-form" autocomplete="off">
        <input type="hidden" name="step" value="send" />
        <div class="input-group">
          <select id="country-code">
              ${generateCountryCodeOptions(window.hyperOTPSettings)}
          </select>
          <input name="identifier" placeholder="  Phone Number" value="${prefillPhone ? prefillPhone : ''}" />
        </div>
        <button type="submit" class="otp-btn">Get OTP</button>
      </form>
      <div class="divider"><span style="font-size: 12px; font-weight: 600; color: #000000;">OR</span></div>
      <div class="social-row">
        ${!loadingSocial ? `
          <button type="button" class="social-btn google-sso-btn">
            <img src='https://img.icons8.com/color/48/google-logo.png' alt='Google' />
          </button>
          ${getEnabledSocialLogins().facebook ? `
            <button type="button" class="otp-social-btn social-btn facebook-sso-btn">
              <img src='https://img.icons8.com/fluency/48/facebook-new.png' alt='Facebook' />
              <span style="font-size:0;">Facebook</span>
            </button>
          ` : ''}
        ` : ''}
      </div>
      <button type="button" class="email-btn" disabled >Login with Email &amp; Password</button>
    `;
  
    // Attach OTP form handler immediately
    const otpForm = otpContainer.querySelector('#otp-form');
    if (otpForm) {
      attachOtpFormHandler(otpForm, otpContainer);
  
      // Remove whitespace as user types in phone input
      const phoneInput = otpForm.querySelector('input[name="identifier"]');
      if (phoneInput) {
        phoneInput.addEventListener('input', function (e) {
          const cursor = phoneInput.selectionStart;
          const newValue = phoneInput.value.replace(/\s+/g, '');
          if (phoneInput.value !== newValue) {
            phoneInput.value = newValue;
            phoneInput.setSelectionRange(cursor - 1, cursor - 1);
          }
        });
      }
  
      // Handle country code dropdown to show only code after selection
      const countrySelect = otpForm.querySelector('#country-code');
      if (countrySelect) {
        // Store original text for each option
        const originalOptions = {};
        countrySelect.querySelectorAll('option').forEach(option => {
          originalOptions[option.value] = option.textContent;
        });
  
        // Function to update display text
        function updateCountryDisplay() {
          const selectedOption = countrySelect.options[countrySelect.selectedIndex];
          if (selectedOption) {
            const countryCode = selectedOption.value;
            const countryName = selectedOption.getAttribute('data-country');
  
            // Show full text in dropdown options
            countrySelect.querySelectorAll('option').forEach(option => {
              option.textContent = originalOptions[option.value];
            });
  
            // Update selected option to show only country code
            selectedOption.textContent = countryCode;
  
            // Adjust width based on country code length
            if (countryCode.length === 3) {
              // 3 digits like +91, +86, +44
              countrySelect.style.width = '55px';
              countrySelect.style.minWidth = '55px';
            } else if (countryCode.length === 2) {
              // 2 digits like +1
              countrySelect.style.width = '55px';
              countrySelect.style.minWidth = '55px';
            } else {
              // 4+ digits like +852, +886, +258
              countrySelect.style.width = '65px';
              countrySelect.style.minWidth = '65px';
            }
          }
        }
  
        // Update display on change
        countrySelect.addEventListener('change', updateCountryDisplay);
  
        // Initial update
        updateCountryDisplay();
      }
    }
  
    // Apply dynamic button colors and header text after form is rendered
    updateButtonColors();
    updateHeaderText();
  }
  
  function hydrateOtpContainer(otpContainer) {
    if (!otpContainer) return;
  
    renderInitialForm(otpContainer, { loadingSocial: false });
  
    const { google, facebook } = getEnabledSocialLogins();
    const showOTPForm = shouldShowOTPForm();
    const showEmailPassword = shouldShowEmailPasswordLogin();
  
    const googleButton = otpContainer.querySelector('.google-sso-btn');
    const facebookButton = otpContainer.querySelector('button:has(img[alt="Facebook"])');
    const emailButton = otpContainer.querySelector('.email-btn');
    const divider = otpContainer.querySelector('.divider');
    const otpFormElement = otpContainer.querySelector('#otp-form');
  
    if (googleButton) {
      if (google) {
        googleButton.disabled = false;
        googleButton.style.opacity = '1';
      } else {
        googleButton.style.display = 'none';
      }
    }
  
    if (facebookButton) {
      if (facebook) {
        facebookButton.disabled = false;
        facebookButton.style.opacity = '1';
      } else {
        facebookButton.style.display = 'none';
      }
    }
  
    if (emailButton) {
      if (showEmailPassword) {
        emailButton.disabled = false;
        emailButton.style.opacity = '1';
      } else {
        emailButton.style.display = 'none';
      }
    }
  
    if (otpFormElement) {
      otpFormElement.style.display = showOTPForm ? 'block' : 'none';
    }
  
    if (divider && !google && !facebook && !showEmailPassword) {
      divider.style.display = 'none';
    }
  
    attachGoogleSSOHandlers();
    attachFacebookSSOHandlers();
    attachEmailPasswordHandlers();
  }

  function createDrawerOtpContainer() {
    const otpContainer = document.createElement('div');
    otpContainer.id = `otp-login-container-drawer-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
    otpContainer.className = 'otp-login-container otp-fade-in';
    otpContainer.dataset.hyperotpContext = 'drawer';
    otpContainer.style.cssText = `
      background: transparent;
      max-width: 100%;
      margin: 16px 0 24px 0;
      border-radius: 0;
      box-shadow: none;
      padding: 0 12px 12px 12px;
      font-family: 'Inter', sans-serif;
      opacity: 0;
      transition: opacity 0.33s cubic-bezier(.4,0,.2,1);
      width: 100%;
      box-sizing: border-box;
    `;
    renderInitialForm(otpContainer, { loadingSocial: true });
    return otpContainer;
  }

  function handleDrawerLoginForm(form) {
    if (!form || processedDrawerForms.has(form)) return;

    const settings = window.hyperOTPSettings;
    if (settings && (settings.appEnabled === false || settings.loginMethod === 'ONLY_EMAIL_PASSWORD')) {
      return;
    }
    const drawerHost = getDrawerHost(form);
    if (!drawerHost) {
      processedDrawerForms.add(form);
      return;
    }

    // Skip if this host already uses the primary OTP container
    if (drawerHost.querySelector('.otp-login-container[data-hyperotp-context="primary"]')) {
      processedDrawerForms.add(form);
      return;
    }

    processedDrawerForms.add(form);

    const existingDrawerContainer = drawerHost.querySelector('.otp-login-container[data-hyperotp-context="drawer"]');
    if (existingDrawerContainer) {
      linkHiddenFormToContainer(existingDrawerContainer, form);
      return;
    }

    const otpContainer = createDrawerOtpContainer();
    const parentNode = form.parentElement || drawerHost;
    parentNode.insertBefore(otpContainer, form);
    linkHiddenFormToContainer(otpContainer, form);

    setTimeout(() => {
      if (otpContainer.isConnected) {
        otpContainer.style.opacity = '1';
      }
    }, 10);

    if (window.hyperOTPSettings) {
      hydrateOtpContainer(otpContainer);
    }
  }

  function scanForDrawerLoginForms(root = document) {
    if (!root) return;
    const forms = [];
    if (root.matches && root.matches('form[action*="/account/login"]')) {
      forms.push(root);
    }
    if (typeof root.querySelectorAll === 'function') {
      root.querySelectorAll('form[action*="/account/login"]').forEach(form => forms.push(form));
    }
    forms.forEach(handleDrawerLoginForm);
  }

  function initializeDrawerLoginWatcher() {
    scanForDrawerLoginForms(document);

    const drawerObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;
          scanForDrawerLoginForms(node);
        });
      });
    });

    drawerObserver.observe(document.body, { childList: true, subtree: true });
  }
  
  // Function to inject CSS to hide Shopify login form, only if appEnabled is true
  function injectHideLoginCSS() {
    if (document.getElementById('hyperotp-hide-login-style')) return;
    const style = document.createElement("style");
    style.id = "hyperotp-hide-login-style";
    style.innerHTML = `
      /* Hide only the native login form and titles; keep wrappers visible */
      form[action*="/account/login"],
      #customer_login,
      form[action*="/account/login"] *,
      #customer_login h1,
      #customer_login h2,
      /* Common theme headings/text around login */
      .customer.login #login,
      .customer.login .login__text,
      .customer.login .section-content__text,
      .section-header__title,
      .login-title,
      .form-title,
      .customer-login-title,
      .login-rowRight {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        z-index: -1 !important;
      }
      /* Hide promotional elements on login page only */
      body[data-template*="customers/login"] h2.section-title.title.inline-richtext,
      body[data-template*="customers/login"] .section-text.login_description,
      body[data-template*="customers/login"] .banner_buttons--multiple a[href="/account/register"],
      body[data-template*="customers/login"] .inline-block.max-w-xl,
      body[data-template*="customers/login"] .login-rowRight,
      /* Alternative selectors for different theme structures */
      h2.section-title.title.inline-richtext,
      .section-text.login_description,
      .banner_buttons--multiple a[href="/account/register"],
      .inline-block.max-w-xl,
      .login-rowRight {
        display: none !important;
        visibility: hidden !important;
        height: 0 !important;
        opacity: 0 !important;
        pointer-events: none !important;
        position: absolute !important;
        z-index: -1 !important;
      }
    `;
    document.head.appendChild(style);
  }
  
  // Function to show Shopify default login form and remove custom UI
  function showShopifyDefaultLoginForm() {
    const hiddenLoginSection = document.querySelector('.customer.login.section.section--padding[style*="display: none"]');
    const otpContainers = Array.from(document.querySelectorAll('.otp-login-container'));
    
    // First, restore any hidden elements that contain the login form
    const restoreHiddenElements = () => {
      // Restore hidden section content
      const hiddenSectionContent = document.querySelector('.section-content.lg\\:p-0.mr-auto.ml-auto.xs\\:w-full[style*="display: none"]');
      if (hiddenSectionContent) {
        hiddenSectionContent.style.display = '';
      }
      
      // Restore any hidden wrappers or parents
      const hiddenWrappers = document.querySelectorAll('.customer.login[style*="display: none"], #login[style*="display: none"], .customer-login[style*="display: none"], .customer__login[style*="display: none"], [data-login-form][style*="display: none"]');
      hiddenWrappers.forEach(wrapper => {
        wrapper.style.display = '';
      });
      
      // Also check for any parent elements that might be hidden
      const nativeLoginForm = document.querySelector('form[action*="/account/login"]');
      if (nativeLoginForm) {
        let parent = nativeLoginForm.parentElement;
        while (parent && parent !== document.body) {
          if (parent.style && parent.style.display === 'none') {
            parent.style.display = '';
          }
          parent = parent.parentElement;
        }
      }
      
      // Restore originalSectionContent if it was stored
      if (originalSectionContent && originalSectionContent.style) {
        originalSectionContent.style.display = '';
      }
    };
    
    const removeHideStyles = () => {
      const tempStyle = document.getElementById('hyperotp-temp-hide-login-style');
      if (tempStyle) tempStyle.remove();
      const permStyle = document.getElementById('hyperotp-hide-login-style');
      if (permStyle) permStyle.remove();
      // Explicitly restore visibility of login-rowItem and login-rowLeft (left column)
      // Query for elements that might have these classes (including combined classes)
      const loginRowItems = document.querySelectorAll('.login-rowItem, .login-rowLeft, [class*="login-rowItem"], [class*="login-rowLeft"]');
      loginRowItems.forEach(element => {
        element.style.display = '';
        element.style.visibility = '';
        element.style.height = '';
        element.style.opacity = '';
        element.style.pointerEvents = '';
        element.style.position = '';
        element.style.zIndex = '';
        // Also remove any data attributes that might affect visibility
        element.removeAttribute('data-hyperotp-hidden');
      });
      // Also restore login-rowRight in case it was hidden
      const loginRowRights = document.querySelectorAll('.login-rowRight, [class*="login-rowRight"]');
      loginRowRights.forEach(element => {
        element.style.display = '';
        element.style.visibility = '';
        element.style.height = '';
        element.style.opacity = '';
        element.style.pointerEvents = '';
        element.style.position = '';
        element.style.zIndex = '';
        element.removeAttribute('data-hyperotp-hidden');
      });
      // Find and restore any parent containers that might contain these elements
      const loginRowContainer = document.querySelector('[class*="login-row"], [class*="loginRow"], .login-container, [class*="loginContainer"]');
      if (loginRowContainer) {
        loginRowContainer.style.display = '';
        loginRowContainer.style.visibility = '';
        loginRowContainer.style.height = '';
        loginRowContainer.style.opacity = '';
        loginRowContainer.style.pointerEvents = '';
        loginRowContainer.style.position = '';
        loginRowContainer.style.zIndex = '';
      }
    };
  
    if (hiddenLoginSection) {
      const primaryContainer = otpContainers.find(container => container.dataset.hyperotpContext === 'primary') || otpContainers[0];
      if (primaryContainer) {
        primaryContainer.classList.add('otp-fade-out');
        setTimeout(() => {
          destroyOtpContainer(primaryContainer);
          hiddenLoginSection.style.display = '';
          // Restore hidden elements and remove hide styles after restoring the section
          restoreHiddenElements();
          removeHideStyles();
          const loginForm = document.querySelector('form[action="/account/login"]');
          if (loginForm) loginForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 120);
      } else {
        hiddenLoginSection.style.display = '';
        restoreHiddenElements();
        removeHideStyles();
      }
      return;
    }

    // For /account/login page, restore hidden elements first
    restoreHiddenElements();

    if (otpContainers.length) {
      otpContainers.forEach((container, index) => {
        container.classList.add('otp-fade-out');
        setTimeout(() => {
          destroyOtpContainer(container);
          if (index === otpContainers.length - 1) {
            restoreHiddenElements();
            removeHideStyles();
            const loginForm = document.querySelector('form[action="/account/login"]');
            if (loginForm) loginForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 120);
      });
    } else {
      restoreHiddenElements();
      removeHideStyles();
      const loginForm = document.querySelector('form[action="/account/login"]');
      if (loginForm) loginForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  
  // Store reference to original elements for restoration
  let originalSectionContent = null;
  let originalCustomerLoginSection = null;
  
  // Attach handler to all email/password login buttons
  function attachEmailPasswordHandlers() {
    document.querySelectorAll('.otp-email-btn, .email-btn').forEach(btn => {
      btn.removeEventListener('click', btn._emailLoginHandler);
      btn._emailLoginHandler = function (event) {
        event.preventDefault();
        
        // Set window flag to prevent OTP form rendering on subsequent interactions
        window.hyperOTPUseEmailPassword = true;
        showShopifyDefaultLoginForm();
        return false;
      };
      btn.addEventListener('click', btn._emailLoginHandler);
    });
  }
  
  // Initial attach for email/password login
  attachEmailPasswordHandlers();
  
  // Watch for dynamic UI changes
  const emailBtnObserver = new MutationObserver(() => {
    attachEmailPasswordHandlers();
  });
  emailBtnObserver.observe(document.body, { childList: true, subtree: true });
  
  // Add fade-out CSS for smooth transition
  (function addOtpFadeOutCSS() {
    if (document.getElementById('otp-fade-out-style')) return;
    const style = document.createElement('style');
    style.id = 'otp-fade-out-style';
    style.innerHTML = `
      .otp-login-container.otp-fade-out {
        opacity: 0;
        transition: opacity 0.12s ease;
      }
    `;
    document.head.appendChild(style);
  })();
  
  // Add fade-in CSS for OTP UI (in case of SSR or style removal)
  (function addOtpFadeInCSS() {
    if (document.getElementById('otp-fade-in-style')) return;
    const style = document.createElement('style');
    style.id = 'otp-fade-in-style';
    style.innerHTML = `
      .otp-fade-in {
        opacity: 0;
        transition: opacity 0.33s cubic-bezier(.4,0,.2,1);
      }
      .otp-fade-in[style*="opacity: 1"] {
        opacity: 1 !important;
      }
    `;
    document.head.appendChild(style);
  })();
  
  // Add mobile margin/padding for OTP container
  (function injectOtpMobileMarginCSS() {
    if (document.getElementById('otp-login-mobile-style')) return;
    const style = document.createElement('style');
    style.id = 'otp-login-mobile-style';
    style.innerHTML = `
      @media (max-width: 768px) {
        .otp-login-container {
          margin: 20px auto !important;
          padding: 12px 16px 20px 16px !important;
          max-width: calc(100vw - 32px) !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }
        .otp-verify-input {
          font-size: 22px !important;
          letter-spacing: 0.7em !important;
          padding: 0 6px !important;
        }
        .otp-verify-input::placeholder {
          font-size: 18px !important;
        }
      }
      @media (max-width: 600px) {
        .otp-login-container {
          margin: 16px auto !important;
          padding: 12px 12px 16px 12px !important;
          max-width: calc(100vw - 24px) !important;
        }
        .otp-verify-input {
          font-size: 20px !important;
          letter-spacing: 0.6em !important;
          padding: 0 4px !important;
          height: 42px !important;
        }
        .otp-verify-input::placeholder {
          font-size: 16px !important;
        }
      }
    `;
    document.head.appendChild(style);
  })();